<template>
  <div class="anal-container" v-if="cardData?.dataCatalog?.tabela?.length">
    <div class="labels">
      <div class="lab">
        <span class="cell-container">
          <span class="cell" v-text="$t('date')"></span>
        </span>
      </div>
      <div class="tipos-pratos" id="titulosPratos">
        <div class="dia" v-bind:style="calcGrid(cardData.dataCatalog.tabela[0].colunas.length)">
          <span v-for="datas in cardData.dataCatalog.tabela[0].colunas" v-if="!hideColuns.includes(datas.id_coluna)"
            :key="`header-seq-${datas.id_coluna}`" class="cell-container column-header-hover-trigger"
            :data-column-hover-seq="normalizeSequencialForIA(datas.id_coluna)"
            @mouseenter="handleColumnHoverCellEnter($event, datas)"
            @mousemove="handleColumnHoverCellMove($event, datas)" @mouseleave="handleColumnHoverCellLeave($event)">
            <span class="cell" v-text="cardData.dataCatalog.colunas[datas.id_coluna].nm_tipoprato"></span>
          </span>
        </div>
      </div>
      <div class="lab right">
        <span class="cell-container">
          <span class="cell" v-text="$t('PU_DAY')"></span>
        </span>
        <span class="cell-container">
          <span class="cell" v-text="$t('PU_ACCUMULATED')"></span>
        </span>
      </div>
    </div>

    <div class="card-cont">
      <div class="card-anal-container">
        <div class="fixed-cols left">
          <div class="fixed-cols-cont">

            <div v-for="datas in cardData.dataCatalog.tabela" class="dia"
              :data-ia-day="normalizeDateForIA(datas.data)">
              <span class="cell-container" :class="{ 'noComens': datas.qtde_comensais == 0 }">
                <span class="cell capitalize" v-if="datas.data != 'Data' && datas.qtde_comensais != 'Comensais Estimados'"
                  v-text="formatData(datas.data) + ' - ' + datas.qtde_comensais" :title="showComensinfo(datas)"></span>

                <img class="padlock" v-if="isFrozenDay(datas)" :src="padlock" :title="$t('frozen_day')" />

                <img class="padlock" v-if="isEventDay(datas) && !isFrozenDay(datas)" :src="eventDay"
                  title="Dia de Evento" />
              </span>
            </div>

          </div>
        </div>
        <div id="platesContainer" class="plates">
          <div v-for="(dia, index) in cardData.dataCatalog.tabela" :key="dia.data" class="dia" v-bind:style="calcGrid(Object.keys(cardData.dataCatalog.colunas).length)"
            :data-ia-day="normalizeDateForIA(dia.data)">
            <div class="container-max" :class="{ 'noComens': !coluna.id_prato && coluna.pratos_disponiveis.length === 0 || dia.qtde_comensais == 0 }" v-for="(coluna) in dia.colunas" :key="`${dia.data}-${coluna.id_coluna}`"
              v-if="coluna && !hideColuns.includes(coluna.id_coluna)" v-bind:style="getUiEntry(dia.data, coluna.id_coluna, coluna.id_prato).style"
              :data-ia-seq="normalizeSequencialForIA(coluna.id_coluna)"
              :data-ia-plate-id="normalizePlateIdForIA(coluna.id_prato)"
              :data-ia-cell="buildIaCellKey(dia.data, coluna.id_coluna, coluna.id_prato)"
              @mouseenter="handlePlateHoverCellEnter($event, coluna, index)"
              @mousemove="handlePlateHoverCellMove($event, coluna, index)" @mouseleave="handlePlateHoverCellLeave($event)"
              @click="setColorForGroup(coluna)">
              <span class="cell-container" @click="handleClick(coluna, index)">
                <div class="ings-container" v-if="coluna.id_prato" v-show="showIngs"> 
                  <span
                    :title="getDadosPrato(coluna.id_prato).nm_ingrediente_1"
                    :style="{ color: getContrastColor(ingrColors[getDadosPrato(coluna.id_prato)?.id_ingrediente_1]) }">
                    {{ getDadosPrato(coluna.id_prato).nm_ingrediente_1 }} 
                  </span>
                  <div :style="{ backgroundColor: ingrColors[getDadosPrato(coluna.id_prato)?.id_ingrediente_1] || 'transparent' }"></div>
                  <span :title="getDadosPrato(coluna.id_prato).nm_ingrediente_2"
                    :style="{ color: getContrastColor(ingrColors[getDadosPrato(coluna.id_prato)?.id_ingrediente_2]) }">
                    {{ getDadosPrato(coluna.id_prato).nm_ingrediente_2 }} </span>
                  <div :style="{ backgroundColor: ingrColors[getDadosPrato(coluna.id_prato)?.id_ingrediente_2] || 'transparent' }"></div>
                </div>
                <span class="attached-mark" :style="getUiEntry(dia.data, coluna.id_coluna, coluna.id_prato).palateStyle"
                  v-if="coluna.id_vinculado">
                  <img v-bind:src="attach" title="Prato vinculado" width="10px" v-bind:class="getUiEntry(dia.data, coluna.id_coluna, coluna.id_prato).forkClass" />
                </span>
                <span class="changed-mark" v-if="coluna._meta && coluna._meta.alterado && !['solver', 'solver_IA'].includes(coluna._meta.id_origem)" :title="getChangedTitle(coluna)"></span>
                <span class="cell" v-if="!coluna.id_prato && !coluna.buraco_obrigatorio" v-text="'--'"></span>
                <span class="cell" v-if="!coluna.id_prato && coluna.buraco_obrigatorio" v-text="'Ø'" style="color: red" title="Buraco planejado"></span>
                <span class="cell text" v-if="coluna.id_prato"> 
                  {{ getUiEntry(dia.data, coluna.id_coluna, coluna.id_prato).exib || getDadosPrato(coluna.id_prato).nm_prato }}
                  <span :class="{ 'palate-data': true }" :style="getUiEntry(dia.data, coluna.id_coluna, coluna.id_prato).palateStyle">
                    <img v-bind:src="fork" width="10px" v-bind:class="getUiEntry(dia.data, coluna.id_coluna, coluna.id_prato).forkClass" />
                    <span v-text="parseFloat(coluna.perc_consumo).toFixed(2) + '%'"></span>
                  </span>
                  <span class="palate-data" v-text="'R$ ' + parseFloat(coluna.vlr_custo_percapita).toFixed(5)"
                    :style="getUiEntry(dia.data, coluna.id_coluna, coluna.id_prato).palateStyle"></span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="fixed-cols right">
          <div class="fixed-cols-cont">
            <div v-for="(datas, index) in cardData.dataCatalog.tabela" class="dia"
              v-bind:title="showMeta(index)">
              <span class="cell-container">
                <span class="cell" v-text="setDecimalPlaces(datas.vr_pu_dia)"
                  v-bind:class="{ 'overpu': datas.vr_pu_dia > cardData.custo_pdr }"></span>
              </span>
              <span class="cell-container">
                <span class="cell" v-text="setDecimalPlaces(datas.vr_pu_acumulado)"
                  v-bind:class="{ 'overpu': datas.vr_pu_acumulado > cardData.custo_pdr }"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!feedBackMode">
      <div class="arrow" @click="publishCard()" v-bind:style="unclickable" v-if="hasPermissionToPublishAndShareCard">
        <div class="img-container">
          <div class="img" v-bind:class="{ 'inverted': !loading }"
            v-bind:style="'background-image:url(' + getCurButtonStatus() + ')'"></div>
        </div>
        <span class="desc">{{ $t('publish_current_scenario_menu') }}</span>
      </div>
      <div class="arrow-secondary" @click="showSharePopUp()" v-bind:style="unclickable" v-if="hasPermissionToPublishAndShareCard">
        <div class="img-container">
          <div class="img img-share" v-bind:class="{ 'inverted': !loading }"
            v-bind:style="'background-image:url(' + getCurButtonStatus(true) + ')'"></div>
        </div>
        <span class="desc">{{ $t('share_current_scenario_menu') }}</span>
      </div>

      <div class="arrow arrow-tertiary" :class="{ 'ai-report-deprecated': isAiReportDeprecated }" @click="openAIresult">
        <div class="img-container">
          <div class="img img-share ai-report-trigger"
            style="display:flex; align-items:center; justify-content:center;">
            <i class="fas fa-robot" style="color:white; font-size:24px;"></i>
            <span v-if="aiReportLoading" class="ai-report-spinner"></span>
          </div>
        </div>
        <span class="desc">{{ aiReportHoverLabel }}</span>
      </div>
    </div>

    <div v-else>
      <div class="arrow" @click="finishFeedbackMode" v-bind:style="unclickable">
        <div class="img-container">
          <div class="img" style="display:flex; align-items:center; justify-content:center;">
            <i class="fas fa-check" style="color:white; font-size:24px;"></i>
          </div>
        </div>
        <span class="desc"> {{ $t('finish_feedback') }} </span>
      </div>

      <div class="arrow-secondary" @click="cancelFeedbackMode" v-bind:style="unclickable">
        <div class="img-container">
          <div class="img img-share" style="display:flex; align-items:center; justify-content:center;">
            <i class="fas fa-times" style="color:white; font-size:24px;"></i>
          </div>
        </div>
        <span class="desc">{{ $t('cancel_feedback') }}</span>
      </div>

      <div class="arrow arrow-tertiary" @click="openFeedbackGrid">
        <div class="img-container">
          <div class="img img-share" style="display:flex; align-items:center; justify-content:center;">
            <i class="fas fa-list" style="color:white; font-size:24px;"></i>
          </div>
        </div>
        <span class="desc">{{ $t('list_feedback') }}</span>
      </div>
    </div>

    <div class="anal-data-container" v-if="lastTabelaItem">
      <div class="anal-data">
        <span v-text="$t('total_cost')"></span>
        <span v-text="'R$ ' + calcCust(parseFloat(custoTotal))"></span>
      </div>
      <div class="anal-data">
        <span v-text="$t('total_diners')"></span>
        <span v-text="parseFloat(comensalTotalDiv).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')"></span>
      </div>
      <div class="anal-data">
        <span v-text="$t('minimum_cost_value')"></span>
        <span
          v-text="'R$ ' + parseFloat(cardData.meta.VLR_CUSTO_MIN).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
      </div>
      <div class="anal-data">
        <span v-text="$t('target_value')"></span>
        <span
          v-text="'R$ ' + parseFloat(cardData.P_VRCUSTPADR).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
      </div>
      <div class="anal-data">
        <span v-text="$t('maximum_cost_value')"></span>
        <span
          v-text="'R$ ' + parseFloat(cardData.meta.VRL_CUSTO_MAX).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
      </div>
      <div class="anal-data">
        <span v-text="$t('PU_ACCUMULATED')"></span>
        <span
          v-text="'R$ ' + parseFloat(puAcumulado).toFixed(5).replace('.', ',').replace(/([0-9]{3}),([0-9]{5}$)/g, '.$1,$2')"></span>
      </div>
      <div class="anal-data">
        <span>{{ $t('cost_difference') }}</span>
        <span :style="checkIfLowerThanZero(
          parseFloat(puAcumulado),
          parseFloat(cardData.meta.VLR_CUSTO_MIN),
          parseFloat(cardData.meta.VRL_CUSTO_MAX),
          parseFloat(cardData.custo_pdr)
        )"
          v-text="checkArrow(parseFloat(puAcumulado), parseFloat(cardData.custo_pdr)) + ' R$ ' + Math.abs(diffCusto).toFixed(5).replace('.', ',')"></span>
      </div>
    </div>
    
    <PlatesSubstitution ref="platesSub" @updateCenarioFromPlateSub="updateCenarioFromPlateSub" />

    <FeedbackModal :feedback-text="feedbackText" :show-feedback-error="showFeedbackError"
      :plates-list="feedbackPlatesList" :feedback-id="editingFeedbackId" @update:feedbackText="handleInput"
      @submit="handleFeedbackSubmit" @cancel="handleFeedbackCancel" @showError="clearFeedbackError"
      @delete="handleFeedbackDeleteFromModal" />

    <FeedbackGridModal ref="feedbackGrid" :scenario-id="nrcenario ? nrcenario.NRCENARIOCARD : null"
      @edit="handleFeedbackEdit" @delete="handleFeedbackDelete" />

    <RelatorioIAModal :scenarioId="nrcenario ? nrcenario.NRCENARIOCARD : null" :scenarioVersion="aiScenarioVersion"
      :dataCatalog="cardData.dataCatalog" :autoCloseOnNavigate="true" @report-loading-change="handleReportLoadingChange"
      @report-status-change="handleReportStatusChange" @navigate-to-menu="handleReportNavigate"
      @highlight-request="handleReportHighlightRequest" @clear-highlights-request="handleReportClearHighlights"
      @cardapio-regenerado="handleCardapioRegenerado" />

    <PlateHoverCard :visible="plateHoverCard.visible" :position="plateHoverCard.position"
      :content="plateHoverCard.content" @mouseenter="handlePlateHoverTooltipEnter"
      @mouseleave="handlePlateHoverTooltipLeave" @close="handlePlateHoverTooltipClose" />

    <PlateColumnHoverCard :visible="columnHoverCard.visible" :position="columnHoverCard.position"
      :content="columnHoverCard.content" @mouseenter="handleColumnHoverTooltipEnter"
      @mouseleave="handleColumnHoverTooltipLeave" @close="handleColumnHoverTooltipClose" />

    <PublishErrorsModal
      v-if="showPublishErrors"
      :errors="publishErrors"
      @close="showPublishErrors = false"
    />

    <modal name="shareModal" :height="'auto'">
      <form class="share-form-root" @submit.prevent="generateLink">
        <h3 class="title">
          {{ $t('url_share_title') }}
        </h3>

        <div class="date-fields-container">
          <div class="field">
            <label for="share-date"> * {{ $t('url_share_date') }}:</label>
            <input id="share-date" type="date" v-model="view.shareFormData.date" />
          </div>
        </div>

        <div class="field text-field">
          <label for="share-link">{{ $t('link') }}:</label>
          <div class="input-container">
            <input id="share-link" type="text" v-model="view.shareFormData.link" readonly />
            <button @click="copyShareLinkToClipboard" type="button" class="copy-button"
              :style="{ backgroundImage: 'url(' + copyIcon + ')', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', width: '20px', height: '20px', opacity: '0.6' }">
            </button>
          </div>
        </div>

        <div class="buttonDiv">
          <button type="button" class="button ghost" @click="hideShareModal">
            <i class="fas fa-times"></i> {{ $t('cancel') }}
          </button>

          <button type="submit" class="button" :disabled="view.shareFormData.date === ''">
            {{ $t('generate_link') }}
          </button>
        </div>
      </form>
    </modal>

  </div>
</template>

<script>
/*global localStorage*/
import Util from "@/application/libs/util";
import PlateService from '@/application/services/Plates'
import moment from "moment";
import "moment/locale/pt-br";
import requestModule from "@/application/libs/requestModule";
import permissionManager from "@/application/libs/permissionManager";
import PlatesSubstitution from "@/components/src/PlatesSubstitution";
import PlateHoverCard from "@/components/src/PlateHoverCard.vue";
import PlateColumnHoverCard from "@/components/src/PlateColumnHoverCard.vue";
import FeedbackGridModal from "@/components/src/modals/FeedbackGridModal.vue";
import RelatorioIAModal from "@/components/src/modals/RelatorioIAModal.vue";
import FeedbackModal from "@/components/src/modals/FeedbackModal.vue";
import PublishErrorsModal from "@/components/src/PublishErrorsModal.vue";
import { t } from 'i18next';
import CryptoJS from 'crypto-js';

export default {
  name: "AnalResult",
  props: {
    cardData: {
      type: Object,
      required: true
    },
    hideColuns: {
      type: Array,
      default: () => []
    },
    exibitionMode: {
      type: [Object,String],
      default: () => []
    },
    nrcenario: {
      type: Object,
      default: () => []
    },
    feedBackMode: {
      type: Boolean,
      default: false
    },
    ingrColors: {
      type: Object,
      default: () => []
    }
  },
  components: {
    PlatesSubstitution,
    PlateHoverCard,
    PlateColumnHoverCard,
    FeedbackGridModal,
    RelatorioIAModal,
    FeedbackModal,
    PublishErrorsModal
  },
  data() {
    return {
      languageLocale: null,
      view: {
        shareFormData: {
          date: '',
          link: ''
        },
      },
      showPublishErrors: false,
      publishErrors: [],
      showIngs: false,
      localFeedBackMode: this.feedBackMode,
      showFeedbackError: false,
      feedbackText: "",
      feedbackPlatesList: [],
      openedFromGridEdit: false,
      editingFeedbackId: null,
      padlock: require("../../../static/lock.png"),
      eventDay: require("../../../static/dia_de_evento.png"),
      linkIcon: require("../../../static/link.png"),
      copyIcon: require("../../../static/copy.png"),
      custPrat: {},
      loadingOPT: {
        y: require("../../../static/ic-logo.gif"),
        n: require("../../../static/publish-icon.png"),
      },
      loading: false,
      hasPermissionToPublishAndShareCard: false,
      unclickable: "pointer-events: auto;",
      listPratosFeedback: [],
      fork: require("../../../static/fork.png"),
      attach: require("../../../static/attach.png"),
      usColors: [],
      gppratos: {},
      trad: {
        P: "Preferencial",
        O: "Obrigatório",
        S: "Sim",
        N: "Não",
        // Vermelhos
        VERMELHO: "firebrick", // vermelho forte, padrão
        "VERMELHO ESCURO": "darkred",
        "VERMELHO ENEGRECIDO": "indianred", // tom mais queimado

        // Amarelos / Dourados
        AMARELO: "gold",                   // amarelo principal, forte
        "AMARELO CLARO": "khaki",          // amarelo claro, mais suave
        "AMARELO ESCURO": "olive",         // amarelo mais escuro
        DOURADO: "goldenrod",              // dourado, intermediário entre AMARELO e AMARELO ESCURO

        // Verdes
        VERDE: "seagreen",              // verde médio agradável
        "VERDE CLARO": "lightgreen",
        "VERDE ESCURO": "darkgreen",

        // Rosas / Lilás / Roxo
        ROSA: "hotpink",                // mais vivo
        "ROSA CLARO": "lightpink",
        "ROSA ESCURO": "deeppink",
        LILAS: "violet",
        ROXO: "purple",

        // Marrons / Terrosos
        MARROM: "saddlebrown",
        CARAMELO: "peru",               // caramelo puxado pro marrom
        FERRUGEM: "chocolate",          // tom ferrugem/oxidado
        COBRE: "sienna",                // cobre mais avermelhado
        PARDO: "wheat",                 // bege/pardo claro
        BEGE: "beige",
        "CASTANHO CLARO": "tan",        // castanho mais claro

        // Laranjas / Corais
        LARANJA: "orange",
        CORAL: "coral",
        SALMAO: "salmon",

        // Neutras
        BRANCO: "white",
        PRETO: "slategray",             // não totalmente preto, mas neutro escuro
        AZUL: "royalblue",              // azul mais vivo que "blue"
      },
      aiReportLoading: false,
      aiReportStatusOverride: null,
      iaHighlightReasonsByCell: {},
      iaHighlightRevision: 0,
      iaFocusSequenceTimeout: null,
      plateHoverOpenTimeout: null,
      plateHoverCloseTimeout: null,
      isPlateHoverTooltipActive: false,
      plateHoverBlockedUntilMove: false,
      plateHoverBlockedPointer: null,
      plateHoverCard: {
        visible: false,
        position: {
          top: 0,
          left: 0,
          maxHeight: 0,
          width: 0,
          maxWidth: 0
        },
        content: null,
        context: null
      },
      columnHoverOpenTimeout: null,
      columnHoverCloseTimeout: null,
      isColumnHoverTooltipActive: false,
      columnHoverBlockedUntilMove: false,
      columnHoverBlockedPointer: null,
      columnHoverCard: {
        visible: false,
        position: {
          top: 0,
          left: 0,
          maxHeight: 0,
          width: 0,
          maxWidth: 0
        },
        content: null,
        context: null
      },
      uiState: {},
      // { [cellKey: string]: { style: string|null, exib: string|null, palateStyle: string|null, forkClass: string|null } }

      listFeedbackCellKeys: new Set(),
      // rastreia as cellKeys que foram destacadas pelo feedback mode, para reset cirúrgico
    };
  },
  computed: {
    aiScenarioVersion() {
      return this.resolveScenarioVersionForIA();
    },
    aiReportStatus() {
      const statusFromOverride = this.normalizeAIReportStatus(this.aiReportStatusOverride);
      if (statusFromOverride) {
        return statusFromOverride;
      }
      return this.normalizeAIReportStatus(this.nrcenario?.STATUSRELATORIOIA);
    },
    isAiReportDeprecated() {
      return this.aiReportStatus === 'DEPRECATED';
    },
    aiReportHoverLabel() {
      if (this.isAiReportDeprecated) {
        return this.$t('relatory_deprecated');
      }
      return this.$t('relatory_with_ai_label');
    },
    ctxByDia() {
      const dc = this.cardData.dataCatalog;
      if (!dc) return null;

      const globalCtx = this.buildGlobalContext(dc.combinacao);

      return this.buildMonthContext(
        dc.tabela,
        dc.colunas,
        dc.pratos,
        globalCtx
      );
    },
    lastTabelaItem() {
      const tabela = this.cardData?.dataCatalog?.tabela;
      if (!tabela || !tabela.length) return null;
      if (!tabela[tabela.length - 1].qtde_comensais_acumulado_div){
        let qtde_comensais_acumulado_div = 0;
        for (let index = 0; index < tabela.length; index++) {
          qtde_comensais_acumulado_div += tabela[index].comensais_detalhe.comensais_divisao;
        }
        tabela[tabela.length - 1].qtde_comensais_acumulado_div = qtde_comensais_acumulado_div;
      }
      return tabela[tabela.length - 1];
    },
    diffCusto(){
      return parseFloat(this.cardData.custo_pdr ??0) - parseFloat(this.lastTabelaItem?.vr_pu_acumulado ?? 0);
    },
    puAcumulado() {
      return parseFloat(this.lastTabelaItem?.vr_pu_acumulado ?? 0);
    },

    custoTotal() {
      return parseFloat(this.lastTabelaItem?.vr_pu_detalhe.vr_custo_total_acumulado ?? 0);
    },

    comensalTotal() {
      return parseFloat(this.lastTabelaItem?.qtde_comensais_acumulado ?? 0);
    },
    comensalTotalDiv() {
      return parseFloat(this.lastTabelaItem?.qtde_comensais_acumulado_div ?? 0);
    }
  },
  watch: {
      cardData: {
      handler() {
        this.resetAllUiState();
      },
      deep: false   // não precisa de deep: cardData é substituído por referência ao trocar cenário
    },

    feedBackMode(newVal) {
      this.localFeedBackMode = newVal;
    },
    nrcenario(newScenario, oldScenario) {
      this.aiReportStatusOverride = null;
      const currentScenarioId = this.normalizeScenarioIdForIA(newScenario?.NRCENARIOCARD);
      const previousScenarioId = this.normalizeScenarioIdForIA(oldScenario?.NRCENARIOCARD);

      if (currentScenarioId === previousScenarioId) {
        return;
      }
      this.clearReportHighlights();
    },
    exibitionMode: function () {
      const mode = this.exibitionMode?.vis ?? this.exibitionMode;

      // colorToHex permanece idêntico ao atual — helper local puro
      const colorToHex = (color) => {
        const ctx = document.createElement("canvas").getContext("2d");
        ctx.fillStyle = color;
        return ctx.fillStyle;
      };

      // Zera todo o uiState antes de aplicar novo modo
      this.resetAllUiState();
      this.showIngs = mode === 'ings';

      if (!mode || mode === 'reset' || mode === 'ings') return;

      const colunasInfo = this.cardData.dataCatalog.colunas;
      const pratosInfo = this.cardData.dataCatalog.pratos;
      const gruposInfo = this.cardData.dataCatalog.grupos;
      const proteinasInfo = this.cardData.dataCatalog.proteinas;
      const ignoredRules = this.cardData.dataCatalog.ignoredRules;
      this.cardData.dataCatalog.tabela.forEach((diaObj) => {
        const data = diaObj.data;
        const ctx = this.ctxByDia.get(data);

        diaObj.colunas.forEach((coluna) => {

          let backgroundColor = null;
          const cellKey = this.makeCellKeyFromColuna(coluna, data);
          const entry = this.getOrCreateUiEntry(cellKey);

          switch (mode) {
            case "obg":
              if (coluna.utilizacao_prato === "O") {
                backgroundColor = colorToHex("firebrick");
              }
              break;

            case "flxRulesPlate":
              if (coluna.id_prato) {
                const exists = ignoredRules?.some(
                  (r) =>
                    r.data === data &&
                    String(r.id_coluna) === String(coluna.id_coluna) &&
                    String(r.id_prato) === String(coluna.id_prato)
                ) || false;
                if(exists) backgroundColor = colorToHex("firebrick");
              }
              break;

            case "conjPorcao": 
              if(coluna.id_prato){
                const cd_grupo_tipoprato = colunasInfo[coluna.id_coluna].cd_grupo_tipoprato;
                const vr_conjuntoPorcao = colunasInfo[coluna.id_coluna].vr_perc_conjunto;
                const consumoConjunto = ctx.consumoByGrupoTpPrato.get(cd_grupo_tipoprato) || 0;

                if (vr_conjuntoPorcao && Math.abs(consumoConjunto - vr_conjuntoPorcao) > 0.001) {
                  backgroundColor = colorToHex("firebrick");
                }
              }
              break;

            case "colors":
              if (coluna.id_prato && pratosInfo[coluna.id_prato].cor) {
                backgroundColor = pratosInfo[coluna.id_prato].cor === "NA" || null
                  ? "#F0F0F0"
                  : colorToHex(this.trad[pratosInfo[coluna.id_prato].cor]);
              }
              break;

            case "groups":
              if (coluna.id_prato) {
                const id_grupo = pratosInfo[coluna.id_prato].id_grupo;
                entry.exib = gruposInfo[id_grupo].nm_grupo;
              }
              break;

            case "typeProt":
              if (coluna.id_prato) {
                const id_proteina = pratosInfo?.[coluna.id_prato]?.id_proteina;
                entry.exib = proteinasInfo?.[id_proteina]?.nm_proteina || 'NA';
              }
              break;

            case "combination":
              //se meu prato esta em uma combinacao (ou seu grupo), verifico se alguem do par ja esta colorido, se estiver, uso a mesma cor, senao crio uma cor para o seu grupo
              if (coluna.id_prato) {
                const grupo = pratosInfo[coluna.id_prato].id_grupo;
                let combinacoes = [];

                if (ctx.combinacaoByPrato.has(coluna.id_prato)) {
                  combinacoes.push(...ctx.combinacaoByPrato.get(coluna.id_prato));
                }

                if (ctx.combinacaoByGrupo.has(grupo)) {
                  combinacoes.push(...ctx.combinacaoByGrupo.get(grupo));
                }

                if (combinacoes.length) {
                  const keys = new Set();
                  const grupos = new Set();
                  combinacoes.forEach((comb) => {
                    //prato combinado
                    if (comb.id_prato_comb && ctx.colunasByPrato.has(comb.id_prato_comb)) {
                      ctx.colunasByPrato.get(comb.id_prato_comb).forEach((c) => {
                        keys.add(this.makeCellKeyFromColuna(c, data));
                        grupos.add(pratosInfo[comb.id_prato_comb].id_grupo);
                      });
                    }
                    //grupo combinado
                    if (comb.id_grupo_comb && ctx.colunasByGrupo.has(comb.id_grupo_comb)) {
                      ctx.colunasByGrupo.get(comb.id_grupo_comb).forEach((c) => {
                        keys.add(this.makeCellKeyFromColuna(c, data));
                        grupos.add(comb.id_grupo_comb);
                      });
                    }
                  });

                  if (keys.size) {
                    keys.add(this.makeCellKeyFromColuna(coluna, data, coluna.id_prato));
                    let randomColor = this.gppratos[grupo];

                    if (!randomColor) {
                      for (const g of grupos) {
                        if (this.gppratos[g]) {
                          randomColor = this.gppratos[g];
                          break;
                        }
                      }
                    }

                    if (!randomColor) {
                      randomColor = this.getRandomColor();
                      this.usColors.push(randomColor);
                    }
                    grupos.add(grupo);
                    for (const g of grupos) {
                      if (!this.gppratos[g]) this.gppratos[g] = randomColor;
                    }
                    const bgHex = colorToHex(randomColor);
                    keys.forEach((k) => {
                      const entry = this.getOrCreateUiEntry(k);
                      entry.style = `background-color: ${bgHex}`;
                      if (this.needContrast(bgHex))  this.applyContrastToEntry(entry);
                    });
                  }
                }
              }
              break;
          }

          if (backgroundColor) {
            if (mode === "colors" && coluna.id_prato && pratosInfo[coluna.id_prato].cor === 'COLORIDA(O)') {
              entry.style = "background: linear-gradient(45deg, rgba(255,127,80,1) 0%, rgba(255,218,121,1) 50%, rgba(144,238,144,1) 100%)";
            } else {
              entry.style = `background-color: ${backgroundColor}`;
              if (this.needContrast(backgroundColor)) {
                this.applyContrastToEntry(entry);
              }
            }
          }
        });
      });
    },

    localFeedBackMode(newVal, oldVal) {
      if (!newVal && oldVal) {
        // Reset cirúrgico: só as células que o feedback mode tinha destacado
        this.listFeedbackCellKeys.forEach((k) => this.resetUiEntry(k));
        this.listFeedbackCellKeys.clear();
        this.listPratosFeedback = [];
        this.feedbackPlatesList = [];
        this.editingFeedbackId = null;
        this.openedFromGridEdit = false;
      }
    },
  },

  updated() {
    this.makeHorizontalDefault();
  },

  mounted() {
    this.loading = false;
    this.makeHorizontalDefault();
    //console.log(this.cardData);
    //console.log("FEEDBACK MODE: ", this.feedBackMode);

    this.languageLocale = localStorage.getItem('lang') || 'pt-br';

    this.resetShareDate();
    window.addEventListener('mousemove', this.handleGlobalPlateHoverMouseMove, true);
  },

  created() {
    this.hasPermissionToPublishAndShareCard = permissionManager.getPermissionToPublishCard();
  },

  beforeDestroy() {
    this.clearReportFocusSequenceTimeout();
    this.clearPlateHoverOpenTimeout();
    this.clearPlateHoverCloseTimeout();
    this.clearColumnHoverOpenTimeout();
    this.clearColumnHoverCloseTimeout();
    window.removeEventListener('mousemove', this.handleGlobalPlateHoverMouseMove, true);
  },



  methods: {
    //indexacao do cardapio para mudancas visuais
    buildGlobalContext(combinacao) {
      const combinacaoByPrato = new Map();
      const combinacaoByGrupo = new Map();

      combinacao.forEach((c) => {
        if (c.id_prato) {
          if (!combinacaoByPrato.has(c.id_prato)) {
            combinacaoByPrato.set(c.id_prato, []);
          }
          combinacaoByPrato.get(c.id_prato).push(c);
        }

        if (c.id_grupo) {
          if (!combinacaoByGrupo.has(c.id_grupo)) {
            combinacaoByGrupo.set(c.id_grupo, []);
          }
          combinacaoByGrupo.get(c.id_grupo).push(c);
        }
      });

      return { combinacaoByPrato, combinacaoByGrupo };
    },

    buildMonthContext(tabela, colunasInfo, pratosInfo, globalCtx) {
      const ctxByDia = new Map();

      tabela.forEach((diaObj) => {
        const ctx = {
          consumoByGrupoTpPrato: new Map(),
          colunasByPrato: new Map(),
          colunasByGrupo: new Map(),

          // reaproveita
          combinacaoByPrato: globalCtx.combinacaoByPrato,
          combinacaoByGrupo: globalCtx.combinacaoByGrupo
        };

        diaObj.colunas.forEach((c) => {
          const colInfo = colunasInfo[c.id_coluna];
          if (!colInfo) return;

          const tipo = colInfo.cd_grupo_tipoprato;
          const consumo = parseFloat(c.perc_consumo || 0);

          ctx.consumoByGrupoTpPrato.set(
            tipo,
            (ctx.consumoByGrupoTpPrato.get(tipo) || 0) + consumo
          );

          const prato = c.id_prato;
          const grupo = prato && pratosInfo[prato]?.id_grupo;

          if (prato) {
            if (!ctx.colunasByPrato.has(prato)) {
              ctx.colunasByPrato.set(prato, []);
            }
            ctx.colunasByPrato.get(prato).push(c);
          }

          if (grupo) {
            if (!ctx.colunasByGrupo.has(grupo)) {
              ctx.colunasByGrupo.set(grupo, []);
            }
            ctx.colunasByGrupo.get(grupo).push(c);
          }
        });

        ctxByDia.set(diaObj.data, ctx);
      });

      return ctxByDia;
    },
    // Retorna (criando se necessário) a entrada reativa de uiState para uma cellKey.
    // Vue 2 exige $set para que a chave nova seja observada reativamente.
    getOrCreateUiEntry(cellKey) {
      if (!cellKey) return { style: null, exib: null, palateStyle: null, forkClass: null };
      if (!this.uiState[cellKey]) {
        this.$set(this.uiState, cellKey, { style: null, exib: null, palateStyle: null, forkClass: null });
      }
      return this.uiState[cellKey];
    },

    // Reseta uma entrada específica sem afetar as demais (usado no feedback cirúrgico).
    resetUiEntry(cellKey) {
      if (cellKey && this.uiState[cellKey]) {
        this.$set(this.uiState, cellKey, { style: null, exib: null, palateStyle: null, forkClass: null });
      }
    },

    // Limpa todo o uiState de uma vez (troca de cenário, mudança de modo).
    // $set no this garante que Vue detecta a troca do objeto inteiro.
    resetAllUiState() {
      this.$set(this, 'uiState', {});
      this.listFeedbackCellKeys.clear();
    },

    // Aplica as propriedades de contraste (texto branco) em uma entrada de uiState.
    // Substitui contrastCell(pt) que mutava o objeto de domínio.
    applyContrastToEntry(entry) {
      if (entry.style) {
        entry.style += '; color: white;';
      } else {
        entry.style = 'color: white;';
      }
      entry.palateStyle = 'color: white';
      entry.forkClass = 'image-contrast';
    },

    // Chamado pelo template: retorna a entrada de uiState para uma célula sem
    // precisar repetir buildIaCellKey no template. Retorna objeto vazio (nulls)
    // se não houver entrada — o template usa fallback do domínio via ||.
    getUiEntry(date, idColuna, idPrato) {
      const key = this.buildIaCellKey(date, idColuna, idPrato);
      return (key && this.uiState[key]) || { style: null, exib: null, palateStyle: null, forkClass: null };
    },

    // Resolve a cellKey a partir de um objeto coluna de dataCatalog.tabela[key].colunas
    // e da data do dia correspondente. Centraliza a lógica de construção da chave
    // para uso nos watchers (que não têm acesso direto ao 'key' do v-for do template).
    makeCellKeyFromColuna(coluna, data) {
      return this.buildIaCellKey(data, coluna.id_coluna, coluna.id_prato);
    },    
    normalizeScenarioIdForIA(value) {
      if (value === null || value === undefined) return null;
      const normalized = String(value).trim();
      return normalized.length ? normalized : null;
    },
    normalizeScenarioVersionValue(value) {
      if (value === null || value === undefined) return null;
      const normalized = String(value).trim();
      return normalized.length ? normalized : null;
    },
    normalizeAIReportStatus(status) {
      if (status === null || status === undefined) return null;
      const normalized = String(status).trim().toUpperCase();
      return normalized.length ? normalized : null;
    },
    resolveScenarioVersionFromSource(source) {
      if (!source || typeof source !== 'object') return null;

      const directCandidates = [
        source.VERSAOCENARIO,
        source.VERSION,
        source.version,
        source.VERSAO,
        source.versao,
        source.NRVERSAO,
        source.NRVERSAOCENARIO,
        source.SCENARIO_VERSION,
        source.scenarioVersion,
        source.NRITGERACAOCARD
      ];
      for (const candidate of directCandidates) {
        const normalized = this.normalizeScenarioVersionValue(candidate);
        if (normalized) return normalized;
      }

      const metadataCandidates = [
        source?.metadata?.scenario?.version,
        source?.metadata?.scenarioVersion
      ];
      for (const candidate of metadataCandidates) {
        const normalized = this.normalizeScenarioVersionValue(candidate);
        if (normalized) return normalized;
      }

      for (const [key, value] of Object.entries(source)) {
        if (value === null || value === undefined || typeof value === 'object') continue;
        const keyNormalized = String(key).toLowerCase();
        if (
          keyNormalized.includes('version')
          || keyNormalized.includes('versao')
          || keyNormalized.includes('itgeracaocard')
        ) {
          const normalized = this.normalizeScenarioVersionValue(value);
          if (normalized) return normalized;
        }
      }

      return null;
    },
    resolveScenarioVersionForIA() {
      const fromScenario = this.resolveScenarioVersionFromSource(this.nrcenario);
      if (fromScenario) return fromScenario;

      const fromCatalog = this.resolveScenarioVersionFromSource(this.cardData?.dataCatalog);
      if (fromCatalog) return fromCatalog;

      return this.resolveScenarioVersionFromSource(this.cardData);
    },
    getScenarioData() {
      return {
        nrorg: Util.getLocalVar("userData").NRORG,
        nrcenario: this.nrcenario ? this.nrcenario.NRCENARIOCARD : null
      };
    },
    handleInput(feedbackText) {
      this.feedbackText = feedbackText;
      this.showFeedbackError = false;
    },
    finishFeedbackMode() {
      if (this.listPratosFeedback.length === 0) {
        Util.showErrorNotification({
          title: t('error'),
          text: t('feedback_no_plates_selected'),
        });
        return;
      }

      this.showFeedbackPopUp({
        text: "",
        plates: this.listPratosFeedback
      });
      this.openedFromGridEdit = false;
      this.editingFeedbackId = null;
    },
    openFeedbackGrid() {
      if (this.$refs.feedbackGrid?.loadFeedbacks) {
        this.$refs.feedbackGrid.loadFeedbacks();
      }
      this.$modal.show("feedbackGridModal", {});
    },
    openAIresult() {
      this.$modal.show("RelatorioIAModal", {});
    },
    handleReportLoadingChange(value) {
      this.aiReportLoading = !!value;
    },
    handleReportStatusChange(payload = {}) {
      const normalizedStatus = this.normalizeAIReportStatus(payload.status);
      this.aiReportStatusOverride = normalizedStatus;

      if (!this.nrcenario || typeof this.nrcenario !== 'object') {
        return;
      }

      if (normalizedStatus) {
        this.$set(this.nrcenario, 'STATUSRELATORIOIA', normalizedStatus);
      }
      if (payload.scenarioVersion !== undefined) {
        this.$set(this.nrcenario, 'VERSAOCENARIO', payload.scenarioVersion);
      }
      if (payload.reportVersion !== undefined) {
        this.$set(this.nrcenario, 'VERSAORELATORIOIA', payload.reportVersion);
      }
    },
    normalizeDateForIA(dateString) {
      if (!dateString || dateString === 'Data') return null;
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) return dateString;
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
      }
      const parsed = new Date(dateString);
      if (Number.isNaN(parsed.getTime())) return null;
      return parsed.toLocaleDateString('pt-BR');
    },
    normalizeSequencialForIA(value) {
      if (value === null || value === undefined) return null;
      const normalized = String(value).trim();
      return normalized.length ? normalized : null;
    },
    normalizePlateIdForIA(value) {
      if (value === null || value === undefined) return null;
      const normalized = String(value).trim();
      return normalized.length ? normalized : null;
    },
    buildIaCellKey(date, sequencial, plateId) {
      const normalizedDate = this.normalizeDateForIA(date);
      if (!normalizedDate) return null;
      return [
        normalizedDate,
        this.normalizeSequencialForIA(sequencial) || '-',
        this.normalizePlateIdForIA(plateId) || '-'
      ].join('::');
    },
    normalizeHighlightTypeForIA(value) {
      if (!value) return 'conflict';
      const normalized = String(value).trim().toLowerCase();
      if (normalized === 'usage' || normalized === 'candidate' || normalized === 'conflict') {
        return normalized;
      }
      return 'conflict';
    },
    normalizeHighlightReasonLabelForIA(value) {
      if (typeof value !== 'string') return null;
      const normalized = value.trim();
      return normalized.length ? normalized : null;
    },
    normalizeHighlightReasonKeyForIA(value) {
      if (typeof value !== 'string') return null;
      const normalized = value.trim();
      return normalized.length ? normalized : null;
    },
    normalizeHighlightReasonLabelsForIA(value) {
      if (!Array.isArray(value)) return [];
      const labels = value
        .map((label) => this.normalizeHighlightReasonLabelForIA(label))
        .filter(Boolean);
      return Array.from(new Set(labels));
    },
    normalizeHighlightTargetForIA(target, fallbackType = 'conflict') {
      const normalizedDate = this.normalizeDateForIA(target?.date);
      if (!normalizedDate) return null;
      const reasonLabels = this.normalizeHighlightReasonLabelsForIA(target?.reasonLabels);
      const reasonLabel = this.normalizeHighlightReasonLabelForIA(target?.reasonLabel) || reasonLabels[0] || null;
      return {
        date: normalizedDate,
        sequencial: this.normalizeSequencialForIA(target?.sequencial),
        plateId: this.normalizePlateIdForIA(target?.plateId),
        highlightType: this.normalizeHighlightTypeForIA(target?.highlightType || fallbackType),
        reasonLabel,
        reasonKey: this.normalizeHighlightReasonKeyForIA(target?.reasonKey),
        reasonLabels,
        origin: target?.origin || null,
        ruleId: target?.ruleId || null,
        source: target?.source || null,
      };
    },
    buildHighlightReasonEntryForIA(target) {
      const labels = this.normalizeHighlightReasonLabelsForIA(target?.reasonLabels);
      const fallbackLabels = target?.reasonLabel ? [target.reasonLabel] : [];
      const mergedLabels = Array.from(new Set([...labels, ...fallbackLabels]
        .map((label) => this.normalizeHighlightReasonLabelForIA(label))
        .filter(Boolean)));
      const normalizedRuleId = target?.ruleId ? String(target.ruleId).trim() : null;
      const normalizedSource = target?.source ? String(target.source).trim() : null;
      const normalizedOrigin = target?.origin ? String(target.origin).trim() : null;
      const fallbackReasonLabel = normalizedRuleId
        ? `Regra ${normalizedRuleId} - ${target?.highlightType || 'conflict'}`
        : `Highlight - ${target?.highlightType || 'conflict'}`;
      const primaryLabel = mergedLabels[0]
        || this.normalizeHighlightReasonLabelForIA(target?.reasonLabel)
        || fallbackReasonLabel;
      const reasonKey = this.normalizeHighlightReasonKeyForIA(target?.reasonKey);
      const fingerprint = [
        normalizedRuleId || '-',
        target?.highlightType || 'conflict',
        reasonKey || primaryLabel || '-',
        normalizedSource || '-',
        normalizedOrigin || '-',
      ].join('::');

      return {
        reasonLabel: primaryLabel,
        reasonKey,
        reasonLabels: mergedLabels,
        ruleId: normalizedRuleId,
        highlightType: target?.highlightType || 'conflict',
        source: normalizedSource,
        origin: normalizedOrigin,
        fingerprint,
      };
    },
    getHighlightReasonsForCellFromIA(cellKey) {
      if (!cellKey) return [];
      const reasons = this.iaHighlightReasonsByCell[cellKey];
      return Array.isArray(reasons) ? reasons : [];
    },
    buildIaHighlightTooltipSection(cellKey) {
      const reasons = this.getHighlightReasonsForCellFromIA(cellKey);
      if (!reasons.length) return '';

      const collected = [];
      reasons.forEach((reason) => {
        const labels = Array.isArray(reason?.reasonLabels) && reason.reasonLabels.length
          ? reason.reasonLabels
          : [reason?.reasonLabel].filter(Boolean);
        labels.forEach((label) => {
          const normalized = this.normalizeHighlightReasonLabelForIA(label);
          if (normalized) collected.push(normalized);
        });
      });

      const uniqueLabels = Array.from(new Set(collected));
      if (!uniqueLabels.length) return '';

      let section = "\n\nDestaques Ativos\n";
      uniqueLabels.forEach((label) => {
        section += `- ${label}\n`;
      });
      return section;
    },
    registerHighlightReasonForCell(cellKey, target) {
      if (!cellKey) return;
      const reasonEntry = this.buildHighlightReasonEntryForIA(target);
      if (!reasonEntry.reasonLabel && !reasonEntry.reasonLabels.length) return;

      const current = Array.isArray(this.iaHighlightReasonsByCell[cellKey])
        ? this.iaHighlightReasonsByCell[cellKey]
        : [];
      const existing = current.find((item) => item.fingerprint === reasonEntry.fingerprint);

      if (!existing) {
        this.$set(this.iaHighlightReasonsByCell, cellKey, [...current, reasonEntry]);
        this.iaHighlightRevision += 1;
        return;
      }

      const mergedLabels = Array.from(new Set([
        ...(existing.reasonLabels || []),
        ...(reasonEntry.reasonLabels || []),
        existing.reasonLabel,
        reasonEntry.reasonLabel,
      ].filter(Boolean)));

      const updatedEntry = {
        ...existing,
        reasonLabel: existing.reasonLabel || reasonEntry.reasonLabel || null,
        reasonLabels: mergedLabels,
      };

      const updated = current.map((item) => (item.fingerprint === reasonEntry.fingerprint ? updatedEntry : item));
      this.$set(this.iaHighlightReasonsByCell, cellKey, updated);
      this.iaHighlightRevision += 1;
    },
    normalizeComparableTextForIA(value) {
      if (value === null || value === undefined) return '';
      return String(value).trim().toUpperCase();
    },
    hasExplicitHighlightReasonForIA(target) {
      const labels = this.normalizeHighlightReasonLabelsForIA(target?.reasonLabels);
      const reasonLabel = this.normalizeHighlightReasonLabelForIA(target?.reasonLabel);
      return labels.length > 0 || !!reasonLabel;
    },
    findDayIndexByDateForIA(normalizedDate) {
      if (!normalizedDate || !this.cardData?.tabela?.comensais_datas) return -1;
      return this.cardData.tabela.comensais_datas.findIndex((row) => this.normalizeDateForIA(row?.[1]) === normalizedDate);
    },
    getPlateFromTargetForIA(target) {
      if (!target?.date || !this.cardData?.tabela?.pratos) return null;
      const dayIndex = this.findDayIndexByDateForIA(target.date);
      if (dayIndex < 0) return null;

      const dayPlates = this.cardData.tabela.pratos[dayIndex];
      if (!Array.isArray(dayPlates)) return null;

      const targetSeq = this.normalizeSequencialForIA(target?.sequencial);
      if (targetSeq) {
        const bySeq = dayPlates.find((plate) => this.normalizeSequencialForIA(plate?.sequencial) === targetSeq);
        if (bySeq) return bySeq;
      }

      const targetPlateId = this.normalizePlateIdForIA(target?.plateId);
      if (targetPlateId) {
        return dayPlates.find((plate) => (
          this.normalizePlateIdForIA(plate?.prato || plate?.codprato || plate?.idPrato || plate?.id) === targetPlateId
        )) || null;
      }

      return null;
    },
    inferAndRegisterR3ReasonsForIA(resolvedTargets) {
      if (!Array.isArray(resolvedTargets) || !resolvedTargets.length) return;

      // The report modal already sends explicit R3 reasons for current reports.
      // Only infer fallback reasons when every resolved R3 target lacks labels,
      // otherwise we can incorrectly mix scopes such as BY_TYPE and GLOBAL_DAY.
      const hasAnyExplicitReason = resolvedTargets.some((entry) => (
        entry?.target?.ruleId === 'R3' && this.hasExplicitHighlightReasonForIA(entry?.target)
      ));
      if (hasAnyExplicitReason) return;

      const r3Entries = resolvedTargets
        .filter((entry) => entry?.cell && entry?.cellKey && entry?.target?.ruleId === 'R3')
        .map((entry) => ({
          ...entry,
          plate: this.getPlateFromTargetForIA(entry.target),
        }))
        .filter((entry) => entry.plate);

      if (!r3Entries.length) return;

      const dayGroups = new Map();
      r3Entries.forEach((entry) => {
        const day = entry.target?.date;
        if (!dayGroups.has(day)) dayGroups.set(day, []);
        dayGroups.get(day).push(entry);
      });

      const registerByAttribute = (entries, valueGetter, reasonLabelBuilder, reasonType) => {
        const grouped = new Map();
        entries.forEach((entry) => {
          const raw = valueGetter(entry.plate);
          const normalized = this.normalizeComparableTextForIA(raw);
          if (!normalized || normalized === 'NA') return;
          if (!grouped.has(normalized)) {
            grouped.set(normalized, { display: String(raw).trim(), entries: [] });
          }
          grouped.get(normalized).entries.push(entry);
        });

        grouped.forEach((bucket, normalizedToken) => {
          if (!bucket.entries || bucket.entries.length < 2) return;
          const reasonLabel = reasonLabelBuilder(bucket.display);
          bucket.entries.forEach((entry) => {
            this.registerHighlightReasonForCell(entry.cellKey, {
              ruleId: 'R3',
              source: entry.target?.source || 'issue',
              origin: 'inferred',
              highlightType: entry.target?.highlightType || 'conflict',
              reasonLabel,
              reasonKey: `R3:${reasonType}:${entry.target?.date}:${normalizedToken}`,
            });
          });
        });
      };

      dayGroups.forEach((entriesByDay) => {
        registerByAttribute(
          entriesByDay,
          (plate) => plate?.COR_PRATO,
          (value) => t('cor_repetida', { PARAM: value }),
          'color'
        );
        registerByAttribute(
          entriesByDay,
          (plate) => plate?.NMTIPOPROTEINA,
          (value) => t('proteina_repetida', { PARAM: value }),
          'protein'
        );
        registerByAttribute(
          entriesByDay,
          (plate) => plate?.NM_MODO_PREPARO,
          (value) => t('modopreparo_repetido', { PARAM: value }),
          'prep'
        );
      });
    },
    clearReportHighlights() {
      this.clearReportFocusSequenceTimeout();
      this.hidePlateHoverCardImmediate();
      this.$el.querySelectorAll('.ia-highlight-day').forEach((el) => el.classList.remove('ia-highlight-day'));
      this.$el.querySelectorAll('.ia-highlight-cell').forEach((el) => el.classList.remove('ia-highlight-cell'));
      this.$el.querySelectorAll('.ia-highlight-usage').forEach((el) => el.classList.remove('ia-highlight-usage'));
      this.$el.querySelectorAll('.ia-highlight-candidate').forEach((el) => el.classList.remove('ia-highlight-candidate'));
      this.$el.querySelectorAll('.ia-highlight-conflict').forEach((el) => el.classList.remove('ia-highlight-conflict'));
      this.iaHighlightReasonsByCell = {};
      this.iaHighlightRevision += 1;
    },
    getReportRowByDate(date) {
      return this.$el.querySelector(`#platesContainer .dia[data-ia-day="${date}"]`);
    },
    resolveReportCell(row, target) {
      if (!row) return null;
      if (target?.sequencial) {
        const bySeq = row.querySelector(`.container-max[data-ia-seq="${target.sequencial}"]`);
        if (bySeq) return bySeq;
      }
      if (target?.plateId) {
        const byPlate = row.querySelector(`.container-max[data-ia-plate-id="${target.plateId}"]`);
        if (byPlate) return byPlate;
      }
      return null;
    },
    findResolvedTarget(resolvedTargets, target) {
      if (!target) return null;
      return resolvedTargets.find((resolved) => (
        resolved.target.date === target.date
        && (resolved.target.sequencial || null) === (target.sequencial || null)
        && (resolved.target.plateId || null) === (target.plateId || null)
      )) || null;
    },
    scrollToReportFocus(row, targetCell) {
      if (!row) return;
      const gridContainer = this.$el.querySelector('.card-anal-container');
      if (gridContainer) {
        const top = Math.max(0, row.offsetTop - 45);
        gridContainer.scrollTo({ top, behavior: 'smooth' });
      }

      const platesContainer = this.$el.querySelector('#platesContainer');
      const titleContainer = this.$el.querySelector('#titulosPratos');
      if (targetCell && platesContainer) {
        const left = Math.max(0, targetCell.offsetLeft - (platesContainer.clientWidth / 2) + (targetCell.clientWidth / 2));
        platesContainer.scrollTo({ left, behavior: 'smooth' });
        if (titleContainer) {
          titleContainer.scrollTo({ left, behavior: 'smooth' });
        }
      }
    },
    clearReportFocusSequenceTimeout() {
      if (this.iaFocusSequenceTimeout) {
        clearTimeout(this.iaFocusSequenceTimeout);
        this.iaFocusSequenceTimeout = null;
      }
    },
    normalizeReportFocusSequenceDelay(delayMs) {
      const parsed = Number(delayMs);
      if (Number.isFinite(parsed) && parsed >= 0) {
        return parsed;
      }
      return 1000;
    },
    focusReportTargetsSequentially(resolvedTargets, sequenceTargets = [], delayMs = 1000) {
      if (!Array.isArray(sequenceTargets) || sequenceTargets.length < 2) return false;
      const firstTarget = this.findResolvedTarget(resolvedTargets, sequenceTargets[0]);
      const secondTarget = this.findResolvedTarget(resolvedTargets, sequenceTargets[1]);
      if (!firstTarget || !secondTarget) return false;

      this.scrollToReportFocus(firstTarget.row, firstTarget.cell);
      this.clearReportFocusSequenceTimeout();
      this.iaFocusSequenceTimeout = setTimeout(() => {
        this.scrollToReportFocus(secondTarget.row, secondTarget.cell);
        this.iaFocusSequenceTimeout = null;
      }, this.normalizeReportFocusSequenceDelay(delayMs));

      return true;
    },
    applyReportHighlights(targets = [], focusTarget = null, options = {}) {
      this.clearReportFocusSequenceTimeout();
      const skipInitialFocus = options?.skipInitialFocus === true;
      const resolvedTargets = [];
      targets.forEach((target) => {
        const row = this.getReportRowByDate(target.date);
        if (!row) return;

        const cell = this.resolveReportCell(row, target);
        if (cell) {
          cell.classList.add('ia-highlight-cell');
          cell.classList.add(`ia-highlight-${target.highlightType}`);
          const cellKey = cell.getAttribute('data-ia-cell')
            || this.buildIaCellKey(target.date, target.sequencial, target.plateId);
          this.registerHighlightReasonForCell(cellKey, target);
          resolvedTargets.push({ target, row, cell, cellKey });
          return;
        }
        resolvedTargets.push({ target, row, cell, cellKey: null });
      });

      if (!resolvedTargets.length) {
        Util.showErrorNotification({
          title: t('error'),
          text: t('relatorio_navegacao_alvo_nao_encontrado'),
        });
        return null;
      }

      this.inferAndRegisterR3ReasonsForIA(resolvedTargets);

      let resolvedFocus = this.findResolvedTarget(resolvedTargets, focusTarget);
      if (!resolvedFocus) {
        resolvedFocus = resolvedTargets.find(item => item.cell) || resolvedTargets[0];
      }

      if (!skipInitialFocus) {
        this.scrollToReportFocus(resolvedFocus.row, resolvedFocus.cell);
      }

      return { resolvedTargets, resolvedFocus };
    },
    handleReportNavigate(payload) {
      const target = this.normalizeHighlightTargetForIA({
        date: payload?.date,
        sequencial: payload?.sequencial,
        plateId: payload?.plateId,
        highlightType: 'conflict',
      });

      if (!target) {
        Util.showErrorNotification({
          title: t('error'),
          text: t('relatorio_navegacao_alvo_nao_encontrado'),
        });
        return;
      }

      this.$nextTick(() => {
        this.applyReportHighlights([target], target);
      });
    },
    handleReportHighlightRequest(payload) {
      const rawTargets = Array.isArray(payload?.targets) ? payload.targets : [];
      const payloadRuleId = payload?.ruleId ? String(payload.ruleId).trim() : null;
      const payloadSource = payload?.source ? String(payload.source).trim() : null;
      const targets = rawTargets
        .map((target) => this.normalizeHighlightTargetForIA({
          ...target,
          ruleId: target?.ruleId || payloadRuleId,
          source: target?.source || payloadSource,
        }))
        .filter(Boolean);

      if (!targets.length) {
        Util.showErrorNotification({
          title: t('error'),
          text: t('relatorio_navegacao_alvo_nao_encontrado'),
        });
        return;
      }

      const focusTarget = this.normalizeHighlightTargetForIA({
        ...(payload?.focusTarget || targets[0]),
        ruleId: payload?.focusTarget?.ruleId || payloadRuleId || targets[0]?.ruleId || null,
        source: payload?.focusTarget?.source || payloadSource || targets[0]?.source || null,
      });
      const focusSequence = (Array.isArray(payload?.focusSequence) ? payload.focusSequence : [])
        .map((target) => this.normalizeHighlightTargetForIA({
          ...target,
          ruleId: target?.ruleId || payloadRuleId,
          source: target?.source || payloadSource,
        }))
        .filter(Boolean);
      const focusSequenceDelayMs = this.normalizeReportFocusSequenceDelay(payload?.focusSequenceDelayMs);
      const shouldUseFocusSequence = focusSequence.length > 1;

      this.$nextTick(() => {
        const applied = this.applyReportHighlights(targets, focusTarget, { skipInitialFocus: shouldUseFocusSequence });
        if (!applied) return;

        if (shouldUseFocusSequence) {
          const didSequence = this.focusReportTargetsSequentially(
            applied.resolvedTargets,
            focusSequence,
            focusSequenceDelayMs
          );
          if (didSequence) return;
        }

        this.scrollToReportFocus(applied.resolvedFocus.row, applied.resolvedFocus.cell);
      });
    },
    handleReportClearHighlights() {
      this.clearReportHighlights();
    },
    async handleFeedbackSubmit() {
      try {
        if (this.openedFromGridEdit && this.editingFeedbackId) {
          await PlateService.updateFeedback({
            NRFEEDBACKCARD: this.editingFeedbackId,
            JUSTIFICATIVA: this.feedbackText,
            NRORG: Util.getLocalVar("userData").NRORG
          });
        } else {
          const platesPayload = this.feedbackPlatesList && this.feedbackPlatesList.length
            ? this.feedbackPlatesList
            : this.listPratosFeedback;

          await PlateService.insertFeedback(
            this.feedbackText,
            platesPayload,
            this.nrcenario.NRCENARIOCARD
          );
        }

        Util.showSuccessNotification({
          title: t('sucesso'),
          text: t('feedback_salvo_com_sucesso'),
        });

        this.cancelFeedbackMode();
        this.hideFeedbackModal();
      } catch (e) {
        Util.showErrorNotification({
          title: t('erro'),
          text: t('erro_ao_salvar_feedback'),
        });
      }
    },
    clearFeedbackError() {
      this.showFeedbackError = false;
    },
    showFeedbackPopUp({ text = "", plates = [] } = {}) {
      this.feedbackText = text;
      this.feedbackPlatesList = plates || [];
      this.showFeedbackError = false;
      this.$modal.show("feedbackModal", {});
    },
    hideFeedbackModal() {
      this.$modal.hide('feedbackModal');
    },
    handleFeedbackCancel() {
      this.hideFeedbackModal();
      if (this.openedFromGridEdit) {
        if (this.$refs.feedbackGrid?.loadFeedbacks) {
          this.$refs.feedbackGrid.loadFeedbacks();
        }
        this.$modal.show("feedbackGridModal", {});
      }
      this.openedFromGridEdit = false;
      this.editingFeedbackId = null;
    },
    cancelFeedbackMode() {
      this.$emit('update:feedBackMode', false);
    },
    async handleFeedbackEdit(row) {
      this.showFeedbackError = false;
      this.feedbackText = row?.JUSTIFICATIVA || "";
      this.feedbackPlatesList = [];
      this.openedFromGridEdit = true;
      this.editingFeedbackId = row?.NRFEEDBACKCARD || row?.id || null;
      try {
        this.feedbackPlatesList = await PlateService.getFeedbackPlates(row?.NRFEEDBACKCARD) || [];
      } catch (e) {
        this.feedbackPlatesList = [];
      }
      this.$modal.hide('feedbackGridModal');
      this.showFeedbackPopUp({
        text: this.feedbackText,
        plates: this.feedbackPlatesList
      });
    },
    async handleFeedbackDelete(row) {
      const nrfeedbackcard = row?.NRFEEDBACKCARD || row?.id || row;
      if (!nrfeedbackcard) return;
      try {
        await PlateService.deleteFeedback(nrfeedbackcard);
        Util.showSuccessNotification({
          title: t('sucesso'),
          text: t('Feedback_removido_com_sucesso'),
        });
        if (this.$refs.feedbackGrid?.loadFeedbacks) {
          this.$refs.feedbackGrid.loadFeedbacks();
        }
      } catch (e) {
        Util.showErrorNotification({
          title: t('erro'),
          text: t('Erro_ao_remover_feedback'),
        });
        if (this.$refs.feedbackGrid?.loadFeedbacks) {
          this.$refs.feedbackGrid.loadFeedbacks();
        }
      }
    },
    async handleFeedbackDeleteFromModal(id) {
      await this.handleFeedbackDelete(id);
      this.hideFeedbackModal();
      this.openedFromGridEdit = false;
      this.editingFeedbackId = null;
    },
    formatDate(date, fromFormat, toFormat) {
      return date ? moment(date, fromFormat).format(toFormat) : '';
    },
    generateEncryptedBase64(NRORG, NRCENARIOCARD, DTEXPIRACAO) {
      const text = `${NRORG}_${NRCENARIOCARD}_${DTEXPIRACAO}`;
      // Encripta com AES
      const encrypted = CryptoJS.AES.encrypt(text, process.env.AES_KEY).toString();
      // Converte para URL-safe (substitui '+' por '-', '/' por '_', e remove o padding)
      return encrypted
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    },
    hideShareModal() {
      this.$modal.hide('shareModal');
    },
    getContrastColor(bgColor) {
      return this.needContrast(bgColor) ? 'white' : 'black';
    },
    resolveCssColorToHex(color) {
      if (!color || typeof document === 'undefined') return null;
      const ctx = document.createElement("canvas").getContext("2d");
      if (!ctx) return null;
      ctx.fillStyle = color;
      return ctx.fillStyle || null;
    },
    buildPlateColorDetailStyle(colorLabel) {
      if (colorLabel === 'COLORIDA(O)') {
        return {
          color: '#172348',
          background: 'linear-gradient(45deg, rgba(255,127,80,1) 0%, rgba(255,218,121,1) 50%, rgba(144,238,144,1) 100%)',
          borderColor: 'rgba(27, 41, 87, 0.18)',
          boxShadow: 'inset 0 0 0 1px rgba(27, 41, 87, 0.12)',
          display: 'inline-flex',
          alignItems: 'center',
          width: 'fit-content',
          maxWidth: '100%',
          padding: '2px 8px',
          borderRadius: '999px',
          textShadow: '0 1px 1px rgba(255, 255, 255, 0.35)'
        };
      }

      const mappedColor = colorLabel && colorLabel !== "--" && colorLabel !== "NA"
        ? this.trad[colorLabel]
        : null;
      if (!mappedColor) return null;

      const normalizedHex = this.resolveCssColorToHex(mappedColor);
      if (!normalizedHex) {
        return {
          color: mappedColor,
          textShadow: '0 0 1px rgba(255, 255, 255, 0.45)'
        };
      }

      return {
        color: this.getContrastColor(normalizedHex),
        backgroundColor: normalizedHex,
        borderColor: normalizedHex,
        boxShadow: `inset 0 0 0 1px ${normalizedHex}`,
        display: 'inline-flex',
        alignItems: 'center',
        width: 'fit-content',
        maxWidth: '100%',
        padding: '2px 8px',
        borderRadius: '999px'
      };
    },
    extractRgb(color) {
      if (color !== undefined) {
        color = color.slice(1); // remove o '#' do hexadecimal da cor

        const r = parseInt(color.substring(0, 2), 16);
        const g = parseInt(color.substring(2, 4), 16);
        const b = parseInt(color.substring(4, 6), 16);

        return { r, g, b };
      }
    },
    generateLink() {
      const baseURL = window.location.origin;
      const { nrorg, nrcenario } = this.getScenarioData();
      const expirationDate = this.formatDate(this.view.shareFormData.date, "YYYY-MM-DD", "DD/MM/YYYY");

      requestModule.postRequest(`shareCard`, { NRCENARIOCARD: Number(nrcenario), DTEXPIRACAO: expirationDate })
        .then(() => {
          Util.showSuccessNotification({
            title: t('share_link_menu_generated'),
            
          });

          const genCode = this.generateEncryptedBase64(nrorg, nrcenario, expirationDate);
          this.view.shareFormData.link = `${baseURL}/#/cenario/${genCode}`;
        }).catch(() => {
          Util.showErrorNotification({
            title: t('error'),
            text: t('failed_to_publish_the_menu_consult_the_logs'),
          });
        }).finally(() => {
          this.cardData.DTEXPIRACAO = expirationDate;
        });
    },
    copyShareLinkToClipboard() {
      const input = document.getElementById("share-link");

      if (input.value === '') {
        return;
      }

      if (input) {
        input.select();
        document.execCommand("copy");
      }
    },
    resetShareDate() {
      const { nrorg, nrcenario } = this.getScenarioData();
      const baseURL = window.location.origin;

      if (this.cardData.DTEXPIRACAO) {
        const formattedDate = this.formatDate(this.cardData.DTEXPIRACAO, "DD/MM/YYYY", "YYYY-MM-DD");

        this.view.shareFormData.date = formattedDate;
        this.view.shareFormData.link = `${baseURL}/#/cenario/${this.generateEncryptedBase64(nrorg, nrcenario, this.cardData.DTEXPIRACAO)}`;
        return;
      }

      const futureDate = moment().add(10, 'days').format('YYYY-MM-DD');
      this.view.shareFormData.date = futureDate;
      this.view.shareFormData.link = '';
    },
    needContrast(color) {
      const rgb = this.extractRgb(color);

      if (rgb) {
        const luminance =
          (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;

        return luminance <= 0.5;
      }

      return false;
    },
    showComensinfo: function (date) {
      let comens = date ? 
        t('diners_') + `\n` + 
        t('customers_', { PARAM: `${date.comensais_detalhe.comensais_cli}` }) + `\n` + 
        t('donation_', { PARAM: `${date.comensais_detalhe.comensais_doa}` }) + `\n` + 
        t('employees_', { PARAM: `${date.comensais_detalhe.comensais_fun}` }) : null;
      return comens;
    },
    updateCenarioFromPlateSub: function (newCardData) {
      this.$emit("updateCenarioFromPlateSub", newCardData);
    },
    handleCardapioRegenerado: function () {
      this.$emit("regerar-cardapio-ia");
    },
    logBuracosExcel: function () {
      this.$emit("logBuracosExcel");
    },
    getDadosPrato(id_prato) {
      const pratosInfo = this.cardData?.dataCatalog.pratos?.[id_prato];
      const ingredientes = this.cardData?.dataCatalog.ingredientes;

      if (!id_prato || !pratosInfo) {
        return {
          id_prato: null,
          nm_prato: '--',
          id_ingrediente_1: null,
          nm_ingrediente_1: 'NA',
          id_ingrediente_2: null,
          nm_ingrediente_2: 'NA'
        };
      }

      const nm_ingrediente_1 = pratosInfo.id_ingrediente_1
        ? ingredientes?.[pratosInfo.id_ingrediente_1]?.nm_ingrediente || ''
        : '';

      const nm_ingrediente_2 = pratosInfo.id_ingrediente_2
        ? ingredientes?.[pratosInfo.id_ingrediente_2]?.nm_ingrediente || ''
        : '';

      return {
        id_prato: pratosInfo.id_prato,
        nm_prato: pratosInfo.nm_prato,
        id_ingrediente_1: pratosInfo.id_ingrediente_1,
        nm_ingrediente_1,
        id_ingrediente_2: pratosInfo.id_ingrediente_2,
        nm_ingrediente_2
      };
    },
    handleClick(coluna, date_index) {
      if(this.exibitionMode && this.exibitionMode.states && this.exibitionMode.states.groupsOnPointer) return;
      if (this.feedBackMode) {
        this.insertPlatesListFeedback(coluna, date_index)
      } else {
        if(!this.cardData?.dataCatalog?.tabela?.[date_index]?.qtde_comensais) return;
        this.$refs.platesSub.open(coluna, date_index, this.cardData)
      }
    },
    getDadosFeedbackPrato(coluna, data){

      const pratosInfo = coluna.id_prato ? this.cardData?.dataCatalog?.pratos?.[coluna?.id_prato] || {} : {};
      const colunasInfo = this.cardData?.dataCatalog?.colunas?.[coluna?.id_coluna] || {};
      const gruposInfo = pratosInfo ? this.cardData?.dataCatalog?.grupos?.[pratosInfo?.id_grupo]?.nm_grupo || null : null;
      const atratividade = pratosInfo ? this.cardData?.dataCatalog?.atratividade?.[pratosInfo?.id_atratividade]?.nm_atratividade || null : null;
      const md_preparo = pratosInfo? this.cardData?.dataCatalog?.modopreparo?.[pratosInfo?.id_modopreparo]?.nm_modopreparo || null: null;
      const ingrediente_1 = pratosInfo ? this.cardData?.dataCatalog?.ingredientes?.[pratosInfo?.id_ingrediente_1]?.nm_ingrediente || null: null;
      const ingrediente_2 = pratosInfo ? this.cardData?.dataCatalog?.ingredientes?.[pratosInfo?.id_ingrediente_2]?.nm_ingrediente || null: null;
      const tipocorte = pratosInfo ? this.cardData?.dataCatalog?.tipocorte?.[pratosInfo?.id_tipocorte]?.nm_tipocorte || null : null;
      const proteinas = pratosInfo ? this.cardData?.dataCatalog?.proteinas?.[pratosInfo?.id_proteina]?.nm_proteina || null : null;

      const feedbackItem = {
        //dia
        data: data,
        utilizacao_prato: coluna.utilizacao_prato,
        perc_consumo: coluna.perc_consumo,
        vlr_custo_percapita: coluna.vlr_custo_percapita,

        //pratos
        id_prato: pratosInfo?.id_prato, 
        nm_prato: pratosInfo?.nm_prato,
        vlr_prato: pratosInfo?.vlr_prato,
        id_pre_preparo: pratosInfo?.id_pre_preparo ? 'S':'N',
        id_ingrediente_1: pratosInfo?.id_ingrediente_1,
        nm_ingrediente_1: ingrediente_1,
        id_ingrediente_2: pratosInfo?.id_ingrediente_2,
        nm_ingrediente_2: ingrediente_2,
        id_modopreparo: pratosInfo?.id_modopreparo,
        nm_modopreparo: md_preparo,
        id_tipocorte: pratosInfo?.id_tipocorte,
        nm_tipocorte: tipocorte,
        id_proteina: pratosInfo?.id_proteina,
        nm_proteina: proteinas,
        id_atratividade: pratosInfo?.id_atratividade,
        nm_atratividade: atratividade,
        complexidade: pratosInfo?.complexidade ?? "BAIXA",
        cor: pratosInfo?.cor,

        //grupos
        id_grupo: pratosInfo?.id_grupo,
        nm_grupo: gruposInfo,

        //coluna
        id_coluna: coluna.id_coluna,
        cd_tipoprato: colunasInfo?.cd_tipoprato,
        nm_tipoprato: colunasInfo?.nm_tipoprato,
        hasComb: null
      };
      return feedbackItem;
    },
    insertPlatesListFeedback: function (coluna, date_index) {
      if (!coluna.id_prato && coluna.buraco_obrigatorio) return;
      if (!(this.exibitionMode && this.exibitionMode.states && this.exibitionMode.states.groupsOnPointer)) {

        // Resolve a data do dia pelo índice (mantém lógica atual de fallback)
        const data = this.cardData.dataCatalog.tabela[date_index].data;
        const cellKey = this.buildIaCellKey(data, coluna.id_coluna, coluna.id_prato);
        const feedbackItem = this.getDadosFeedbackPrato(coluna, data);
        const index = this.listPratosFeedback.findIndex(
          item => this.buildIaCellKey(item.data, item.id_coluna, item.id_prato) === cellKey
        );
        if (index !== -1) {
          // Deselecionar: remove destaque e rastreamento
          this.listPratosFeedback.splice(index, 1);
          this.resetUiEntry(cellKey);
          this.listFeedbackCellKeys.delete(cellKey);
        } else {
          this.listPratosFeedback.push(feedbackItem);
          const entry = this.getOrCreateUiEntry(cellKey);
          entry.style = 'background-color: #a8d5ff';
          if (cellKey) this.listFeedbackCellKeys.add(cellKey);
        }
      }
    },
    isFrozenDay: function (data) {
      return data?.id_frozenDay;
      return (parseInt(moment(data.data, "DD/MM/YYYY").format("DD")) <= this.cardData.backOfficeData.VLR_CONGELADO);
    },
    isEventDay: function (data) {
      return data?.id_eventDay;
    },
    buildColumnHoverCardContent(headerData) {
      const id_coluna = headerData?.id_coluna;
      if (!id_coluna) return null;
      const colunasInfo = this.cardData?.dataCatalog.colunas[id_coluna] || {};
      if(!colunasInfo) return null;
      
      const percConjunto = colunasInfo.vr_perc_conjunto !== undefined && colunasInfo.vr_perc_conjunto !== null
      ? `${parseFloat(colunasInfo.vr_perc_conjunto).toFixed(2).replace(".", ",")}%`
      : "--";
      const vrPercConsFixo = colunasInfo.vr_percentual_fixo !== undefined && colunasInfo.vr_percentual_fixo !== null
      ? `${parseFloat(colunasInfo.vr_percentual_fixo).toFixed(2).replace(".", ",")}%`
      : "--";
      const consumo = colunasInfo.id_tipo_coluna === 'ATRATIVIDADE'
      ? this.$t('attractiveness')
      : this.$t('historic');
      
      const gruposInfo = this.cardData?.dataCatalog?.grupos || {};
      const pratosInfo = this.cardData?.dataCatalog?.pratos || {};
      const tabela = this.cardData?.dataCatalog?.tabela || [];

      const groupCount = Object.create(null);

      for (let i = 0; i < tabela.length; i++) {
        const dia = tabela[i];
        if (!dia?.colunas) continue;

        for(let j = 0; j < dia.colunas.length; j++){
          const coluna = dia.colunas[j];
          if (!coluna?.id_prato) continue;
          if(!coluna || coluna.id_coluna !== id_coluna) continue;
          const id_prato = coluna.id_prato;
          const prato = pratosInfo[id_prato];
          if (!prato) continue;

          const id_grupo = prato.id_grupo;
          if (id_grupo == null) continue;

          groupCount[id_grupo] = (groupCount[id_grupo] || 0) + 1;
          break;
        }
      }
      const groups = [];
      let totalGroupsCount = 0;

      for (const id in groupCount) {
        const count = groupCount[id];
        totalGroupsCount += count;

        groups.push({
          name: gruposInfo[id]?.nm_grupo || `Grupo ${id}`,
          count
        });
      }

      return {
        columnEyebrow: `Coluna ${id_coluna}`,
        columnTitle: colunasInfo.nm_tipoprato || '--',
        columnSubtitle: colunasInfo.nm_grupo_tipoprato || '',
        details: [
          { label: 'Origem do consumo', value: consumo	|| '--' },
          { label: 'Consumo conjunto porção', value: percConjunto },
          { label: 'Percentual fixo', value: vrPercConsFixo },
        ],
        flags: [
          { label: 'Intercala pratos', value: this.trad[colunasInfo.id_intercala_pratos ? 'S':'N'] , valueBoolean: colunasInfo.id_intercala_pratos },
          { label: 'Coluna fixa', value: this.trad[colunasInfo.id_coluna_fixa ? 'S':'N'] , valueBoolean: colunasInfo.id_coluna_fixa },
          { label: 'Ignora cor', value: this.trad[colunasInfo.id_ignora_cor ? 'S':'N'] , valueBoolean: colunasInfo.id_ignora_cor },
          { label: 'Ignora modo de preparo', value: this.trad[colunasInfo.id_ignora_modopreparo ? 'S':'N'] , valueBoolean: colunasInfo.id_ignora_modopreparo }
        ],
        groups,
        totalGroupsCount
      };
    },
    calcCust: function (cust_total) {
      let masc = cust_total < 1000 ? "$1,$2" : ".$1,$2";
      return parseFloat(cust_total)
        .toFixed(5)
        .replace(".", ",")
        .replace(/([0-9]{3}),([0-9]{5}$)/g, masc);
    },
    checkIfLowerThanZero: function (pu, VLR_CUSTO_MIN, VRL_CUSTO_MAX, custo_pdr) {
      if ((pu > custo_pdr && pu <= VRL_CUSTO_MAX)) {
        return "color: orange";
      }
      else if (pu > VRL_CUSTO_MAX || pu < VLR_CUSTO_MIN) {
        return "color: red";
      }
      return "color: green";
    },
    checkArrow: function (pu, custo_pdr) {
      if (pu > custo_pdr) {
        return '↑';
      } else if (pu < custo_pdr) {
        return '↓';
      }
      return '';
    },
    scrollHorizontally: function (e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      document.getElementById("platesContainer").scrollLeft -= delta * 40; // * by 40
      document.getElementById("titulosPratos").scrollLeft -= delta * 40; // * by 40
      e.preventDefault();
    },
    makeHorizontalDefault: function () {
      if (
        document.getElementById("platesContainer") &&
        document.getElementById("platesContainer").addEventListener
      ) {
        let platesContainer = document.getElementById("platesContainer");
        // IE9, Chrome, Safari, Opera
        platesContainer.addEventListener(
          "mousewheel",
          this.scrollHorizontally,
          false
        );
        // Firefox
        platesContainer.addEventListener(
          "DOMMouseScroll",
          this.scrollHorizontally,
          false
        );
        window.addEventListener("keydown", (e) => {
          /*keyup*/ /*keydown*/ /*keypress*/
          if (e.code == "ArrowLeft" || e.code == "ArrowRight") {
            var delta = e.code == "ArrowLeft" ? 1 : -1;
            document.getElementById("platesContainer").scrollLeft -= delta * 40; // * by 40
            document.getElementById("titulosPratos").scrollLeft -= delta * 40; // * by 40
            e.preventDefault();
          }
          return true;
        });
      }
    },
    getCurButtonStatus: function (isShare) {
      if (isShare) return this.linkIcon;
      return this.loading ? this.loadingOPT.y : this.loadingOPT.n;
    },
    getRandomColor: function () {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      if (this.usColors.includes(color)) {
        return this.getRandomColor();
      }
      return color;
    },
    calcGrid(size) {
      if (size) {
        let gtc = "grid-gap: 2px; grid-template-columns: ";
        let cols = size;
        let perc = "";

        for (let i = 0; i < cols; i++) {
          perc = 100 / cols;
          perc = perc + "vw ";
          //   gtc = gtc + perc;
          gtc = gtc + "200px "; //130
        }
        return gtc;
      }
    },
    formatData: function (date) {
      return moment(date, "DD/MM/YYYY").locale(this.languageLocale).format("DD ddd");
    },
    showMeta: function (index) {
      const tabela = this.cardData?.dataCatalog?.tabela;
      if (!tabela || !tabela.length || index > tabela.length) return null;
      let qtde_comensais_acumulado_div = 0;
      if (!tabela[index].qtde_comensais_acumulado_div){
        for (let i = 0; i <= index; i++) {
          qtde_comensais_acumulado_div += tabela[i].comensais_detalhe.comensais_divisao;
        }
      }
      const comDia = tabela[index].comensais_detalhe.comensais_divisao;
      const comAcu = tabela[index].qtde_comensais_acumulado_div || qtde_comensais_acumulado_div;
      const cusDia = tabela[index].vr_pu_detalhe.vr_custo_total_dia;
      const cusAcu = tabela[index].vr_pu_detalhe.vr_custo_total_acumulado;

      let retorno =
        t('comens_dia') + parseFloat(comDia).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + "\n";
      retorno +=
        t('comens_acumulado') + parseFloat(comAcu).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + "\n";
      retorno +=
        t('custo_total_dia') + t('R$') + this.calcCust(cusDia) + "\n";
      retorno +=
        t('custo_total_acumulado') + t('R$') + this.calcCust(cusAcu) + "\n";
      return retorno;
    },
    setDecimalPlaces: (data) => {
      let isText = isNaN(parseFloat(data));
      return isText ? data : parseFloat(data).toFixed(5).replace(".", ",");
    },
    formatPlateTooltipCurrency(value) {
      const parsed = parseFloat(value);
      if (Number.isNaN(parsed)) return "--";
      return `R$${parsed.toFixed(5).replace(".", ",")}`;
    },
    formatPlateTooltipPercent(value) {
      const parsed = parseFloat(value);
      if (Number.isNaN(parsed)) return "0,00%";
      return `${parsed.toFixed(2).replace(".", ",")}%`;
    },
    formatPlateTooltipInteger(value) {
      const parsed = parseFloat(value);
      if (Number.isNaN(parsed)) return "0";
      return parsed.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    },
    getPlateFrequencyTooltipEntries(prato, grupo, freq_Grupos, freq_pratos, nr_semana) {
      const list = [];
      if(freq_pratos[prato.id_prato]){
        const frequency_p = {
          title: this.$t('plates'),
          stats: [
            this.$t('plate_used', { PARAM: `${prato.qt_utilizado}` }),
            this.$t('this_week',{PARAM: `${prato.qt_utilizado_sem?.[nr_semana]||0}`}),
            this.$t('min_month', { PARAM: `${freq_pratos[prato.id_prato].qt_min_mes}` }),
            this.$t('max_month', { PARAM: `${freq_pratos[prato.id_prato].qt_max_mes}` }),
            this.$t('max_week', { PARAM: `${freq_pratos[prato.id_prato].qt_max_sem}` }),
          ]
        };
        list.push(frequency_p);
      }
      if(freq_Grupos[grupo.id_grupo]){
        const frequency_g = {
          title: this.$t('group_of_dishes'),
          stats: [
            this.$t('group_used',{ PARAM: `${grupo.qt_utilizado}` }),
            this.$t('this_week', {PARAM: `${prato.qt_utilizado_sem?.[nr_semana]||0}`}),
            this.$t('min_month', { PARAM: `${freq_Grupos[grupo.id_grupo].qt_min_mes}` }),
            this.$t('max_month', { PARAM: `${freq_Grupos[grupo.id_grupo].qt_max_mes}` }),
            this.$t('max_week',  { PARAM: `${freq_Grupos[grupo.id_grupo].qt_max_sem}` }),
          ]
        };
        list.push(frequency_g);
      }
      return list;
    },
    getHighlightLabelsForCellKey(cellKey) {
      if (!cellKey) return [];
      const reasons = this.getHighlightReasonsForCellFromIA(cellKey);
      if (!Array.isArray(reasons) || !reasons.length) return [];

      const collected = [];
      reasons.forEach((reason) => {
        const labels = Array.isArray(reason?.reasonLabels) && reason.reasonLabels.length
          ? reason.reasonLabels
          : [reason?.reasonLabel].filter(Boolean);
        labels.forEach((label) => {
          const normalized = this.normalizeHighlightReasonLabelForIA(label);
          if (normalized) collected.push(normalized);
        });
      });

      return Array.from(new Set(collected));
    },
    getHighlightBadgesForCellKey(cellKey) {
      if (!cellKey) return [];
      const reasons = this.getHighlightReasonsForCellFromIA(cellKey);
      if (!Array.isArray(reasons) || !reasons.length) return [];

      const badges = [];
      reasons.forEach((reason) => {
        const labels = Array.isArray(reason?.reasonLabels) && reason.reasonLabels.length
          ? reason.reasonLabels
          : [reason?.reasonLabel].filter(Boolean);
        labels.forEach((label) => {
          const normalized = this.normalizeHighlightReasonLabelForIA(label);
          if (!normalized) return;
          badges.push({
            label: normalized,
            highlightType: this.normalizeHighlightTypeForIA(reason?.highlightType || 'conflict')
          });
        });
      });

      const seen = new Set();
      return badges.filter((badge) => {
        const key = `${badge.highlightType}::${badge.label}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    clearPlateHoverOpenTimeout() {
      if (!this.plateHoverOpenTimeout) return;
      clearTimeout(this.plateHoverOpenTimeout);
      this.plateHoverOpenTimeout = null;
    },
    clearPlateHoverCloseTimeout() {
      if (!this.plateHoverCloseTimeout) return;
      clearTimeout(this.plateHoverCloseTimeout);
      this.plateHoverCloseTimeout = null;
    },
    releasePlateHoverBlockIfMoved(event) {
      if (!this.plateHoverBlockedUntilMove) {
        return true;
      }

      const clientX = event?.clientX;
      const clientY = event?.clientY;
      if (typeof clientX !== 'number' || typeof clientY !== 'number') {
        return false;
      }

      if (!this.plateHoverBlockedPointer) {
        this.plateHoverBlockedPointer = { clientX, clientY };
        return false;
      }

      if (clientX === this.plateHoverBlockedPointer.clientX && clientY === this.plateHoverBlockedPointer.clientY) {
        return false;
      }

      this.plateHoverBlockedUntilMove = false;
      this.plateHoverBlockedPointer = null;
      return true;
    },
    isPlateHoverTooltipElement(element) {
      return !!(element && typeof element.closest === 'function' && element.closest('.plate-hover-card'));
    },
    isPlateHoverCellElement(element) {
      return !!(element && typeof element.closest === 'function' && element.closest('.container-max[data-ia-cell]'));
    },
    buildPlateHoverCardContent(coluna, index) {
      if(!coluna.id_prato) return;
      const pratosInfo = this.cardData?.dataCatalog?.pratos?.[coluna.id_prato] || [];
      const colunasInfo = this.cardData?.dataCatalog?.colunas?.[coluna.id_coluna] || [];
      const gruposInfo = this.cardData?.dataCatalog?.grupos?.[pratosInfo.id_grupo] || [];
      const nm_ingrediente_1 = pratosInfo.id_ingrediente_1 ? this.cardData?.dataCatalog?.ingredientes?.[pratosInfo.id_ingrediente_1].nm_ingrediente || "NA" : "NA";
      const nm_ingrediente_2 = pratosInfo.id_ingrediente_2 ? this.cardData?.dataCatalog?.ingredientes?.[pratosInfo.id_ingrediente_2].nm_ingrediente || "NA" : "NA";
      const nm_modopreparo = pratosInfo.id_modopreparo ? this.cardData?.dataCatalog?.modopreparo?.[pratosInfo.id_modopreparo].nm_modopreparo || "NA" : "NA";
      const nm_proteina = pratosInfo.id_proteina ? this.cardData?.dataCatalog?.proteinas?.[pratosInfo.id_proteina].nm_proteina || "NA" : "NA";
      const nm_atratividade = pratosInfo.id_atratividade ? this.cardData?.dataCatalog?.atratividade?.[pratosInfo.id_atratividade]?.nm_atratividade || "--" : "--";
      const nm_tipocorte = pratosInfo.id_tipocorte ? this.cardData?.dataCatalog?.tipocorte?.[pratosInfo.id_tipocorte].nm_tipocorte || "NA" : "NA";
      const freq_grupos = this.cardData?.dataCatalog?.freq_grupos || [];
      const freq_pratos = this.cardData?.dataCatalog?.freq_pratos || [];
      const diaInfo = this.cardData?.dataCatalog?.tabela[index] || [];

      let previous = "";
      const meta = coluna?._meta;
      const old = coluna?._meta?.oldJson;
      if (meta && old) {
        const nm_prato_ant = this.cardData?.dataCatalog?.pratos?.[old?.id_prato]?.nm_prato || "";
        const map = {
          substituicao_prato: old.id_prato ? `Prato anterior: ${old.id_prato} - ${nm_prato_ant}` : "",
          ajuste_consumo: old.perc_consumo ? `Consumo anterior: ${parseFloat(old.perc_consumo).toFixed(2).replace(".", ",")}%` : "", 
        };
        previous = map[meta.id_acao] || "";
      }
      if (meta?.id_origem === "solver_IA") {
        previous = this.$t('change_based_on_history');
      }
      const ctx = this.ctxByDia.get(diaInfo.data);
      const consumoConjunto = ctx.consumoByGrupoTpPrato.get(colunasInfo.cd_grupo_tipoprato) || 0;
      const comensaisPrato = !Number.isNaN(diaInfo.qtde_comensais) && diaInfo.qtde_comensais > 0
        ? (diaInfo.qtde_comensais * parseFloat(coluna.perc_consumo || 0)) / 100
        : 0;

      const cellKey = this.buildIaCellKey(diaInfo.data, coluna.id_coluna, coluna.id_prato);
      const rawColorLabel = pratosInfo.cor || "--";

      const details = [
        {
          label: this.$t('color_').replace(':', ''),
          value: rawColorLabel,
          toneStyle: this.buildPlateColorDetailStyle(rawColorLabel)
        },
        { label: this.$t('pre_preparation').replace(':', ''), value: this.trad[pratosInfo.id_pre_preparo ? 'S':'N'] || "--" },
        { label: this.$t('use_').replace(':', ''), value: this.trad[coluna.utilizacao_prato] || "--" },
        { label: this.$t('attractiveness_').replace(':', ''), value: nm_atratividade },
        { label: this.$t('TP_cut').replace(':', ''), value: nm_tipocorte || "--" },
        { label: this.$t('MD_prep').replace(':', ''), value: nm_modopreparo },
        { label: this.$t('product_main_1').replace(':', ''), value: nm_ingrediente_1 },
        { label: this.$t('product_main_2').replace(':', ''), value: nm_ingrediente_2 },
        { label: this.$t('type_protein_title').replace(':', ''), value: nm_proteina },
        { label: this.$t('complexity').replace(':', ''), value: pratosInfo.complexidade ?? "--" },
      ];

      const metrics = [
        { label: this.$t('unit_cost').replace(':', ''), value: this.formatPlateTooltipCurrency(pratosInfo.vlr_prato) },
        { label: this.$t('per_capita_cost').replace(':', ''), value: this.formatPlateTooltipCurrency(coluna.vlr_custo_percapita) }
      ];

      if (coluna.percConsOriginal && coluna.percConsOriginal > 0) {
        metrics.push({
          label: 'Consumo original',
          value: `${parseFloat(coluna.percConsOriginal).toFixed(2).replace(".", ",")}%`
        });
      }

      metrics.push(
        {
          label: this.$t('consumption').replace(':', ''),
          value: `${this.formatPlateTooltipInteger(comensaisPrato)} - ${this.formatPlateTooltipPercent(coluna.perc_consumo)}`
        },
        {
          label: 'Total do conjunto no dia',
          value: `${parseFloat(consumoConjunto || 0).toFixed(2).replace(".", ",")}%`
        }
      );

      if (coluna.reducaoConsumo && coluna.reducaoConsumo > 0) {
        metrics.push({
          label: 'Redução de consumo',
          value: `${parseFloat(coluna.reducaoConsumo).toFixed(2).replace(".", ",")}%`
        });
      }
      return {
        groupLabel: `${this.$t('group_').replace(':', '').trim()} ${gruposInfo.nm_grupo || '--'}`,
        plateName: pratosInfo.nm_prato || '--',
        plateCode: pratosInfo.id_prato,
        previous,
        metrics,
        details,
        frequency: this.getPlateFrequencyTooltipEntries(pratosInfo, gruposInfo, freq_grupos, freq_pratos, diaInfo.nr_semana),
        flexibleRules: Array.isArray(this.cardData?.dataCatalog?.ignoredRules)
                        ? this.cardData?.dataCatalog?.ignoredRules
                            .filter(
                              (r) =>
                                r.data === diaInfo.data &&
                                String(r.id_coluna) === String(coluna.id_coluna) &&
                                String(r.id_prato) === String(coluna.id_prato)
                            )
                            .map((r) => this.$t(r.rule))
                        : [],
        highlights: this.getHighlightBadgesForCellKey(cellKey)
      };
    },
    calculatePlateHoverCardPosition(anchorElement, pointerPosition = null) {
      return this.calculateFloatingHoverCardPosition(anchorElement, pointerPosition);
    },
    calculateFloatingHoverCardPosition(anchorElement, pointerPosition = null, options = {}) {
      if (!anchorElement || typeof anchorElement.getBoundingClientRect !== 'function') {
        return {
          top: 12,
          left: 12,
          maxHeight: options.preferredHeight || 380,
          width: options.preferredWidth || 360,
          maxWidth: options.preferredWidth || 360
        };
      }

      const viewportWidth = window.innerWidth || 0;
      const viewportHeight = window.innerHeight || 0;
      const offset = options.offset ?? 12;
      const screenPadding = options.screenPadding ?? 12;
      const minWidth = options.minWidth ?? 280;
      const preferredWidth = options.preferredWidth ?? (viewportWidth <= 1280 ? 320 : 340);
      const tooltipWidth = Math.min(preferredWidth, Math.max(minWidth, viewportWidth - (screenPadding * 2)));
      const minHeight = options.minHeight ?? 360;
      const preferredHeight = options.preferredHeight ?? (viewportHeight <= 820 ? 480 : 600);
      const anchorRect = anchorElement.getBoundingClientRect();
      const maxViewportHeight = Math.max(minHeight, viewportHeight - (screenPadding * 2));
      const tooltipHeight = Math.min(preferredHeight, maxViewportHeight);
      const maxTop = Math.max(screenPadding, viewportHeight - tooltipHeight - screenPadding);
      const maxLeft = Math.max(screenPadding, viewportWidth - tooltipWidth - screenPadding);
      const pointerX = pointerPosition?.clientX ?? anchorRect.left + (anchorRect.width / 2);
      const pointerY = pointerPosition?.clientY ?? anchorRect.top + (anchorRect.height / 2);
      const clamp = (value, min, max) => Math.max(min, Math.min(value, max));

      const rightCandidate = clamp(pointerX + offset, screenPadding, maxLeft);
      const leftCandidate = clamp(pointerX - tooltipWidth - offset, screenPadding, maxLeft);
      const rightDistance = Math.abs(rightCandidate - pointerX);
      const leftDistance = Math.abs(pointerX - (leftCandidate + tooltipWidth));
      const left = rightDistance <= leftDistance ? rightCandidate : leftCandidate;

      const belowCandidate = clamp(pointerY - offset, screenPadding, maxTop);
      const aboveCandidate = clamp(pointerY - tooltipHeight + offset, screenPadding, maxTop);
      const belowDistance = Math.abs(pointerY - belowCandidate);
      const aboveDistance = Math.abs(pointerY - (aboveCandidate + tooltipHeight));
      const top = belowDistance <= aboveDistance ? belowCandidate : aboveCandidate;

      return {
        top,
        left,
        maxHeight: tooltipHeight,
        width: tooltipWidth,
        maxWidth: viewportWidth - (screenPadding * 2)
      };
    },
    openPlateHoverCard(anchorElement, coluna, index, pointerPosition = null) {
      // Guard: não abrir hover para célula sem conteúdo identificável
      if (!anchorElement || !coluna?.id_prato) {
        this.hidePlateHoverCardImmediate();
        return;
      }

      this.plateHoverCard = {
        visible: true,
        position: this.calculatePlateHoverCardPosition(anchorElement, pointerPosition),
        content: this.buildPlateHoverCardContent(coluna, index),
        context: { coluna, index, anchorElement, pointerPosition }
      };
    },
    schedulePlateHoverOpen(anchorElement, pratos, index, pointerPosition = null, delayMs = 500) {
      this.clearPlateHoverOpenTimeout();
      this.clearPlateHoverCloseTimeout();
      this.plateHoverOpenTimeout = setTimeout(() => {
        this.openPlateHoverCard(anchorElement, pratos, index, pointerPosition);
        this.plateHoverOpenTimeout = null;
      }, delayMs);
    },
    schedulePlateHoverClose(delayMs = 120) {
      this.clearPlateHoverCloseTimeout();
      this.plateHoverCloseTimeout = setTimeout(() => {
        if (this.isPlateHoverTooltipActive) {
          this.plateHoverCloseTimeout = null;
          return;
        }
        this.hidePlateHoverCardImmediate();
        this.plateHoverCloseTimeout = null;
      }, delayMs);
    },
    hidePlateHoverCardImmediate() {
      this.clearPlateHoverOpenTimeout();
      this.clearPlateHoverCloseTimeout();
      if (!this.plateHoverCard.visible && !this.plateHoverCard.content) return;
      this.isPlateHoverTooltipActive = false;
      this.plateHoverCard = {
        visible: false,
        position: { top: 0, left: 0, maxHeight: 0, width: 0, maxWidth: 0 },
        content: null,
        context: null
      };
    },
    handlePlateHoverCellEnter(event, coluna, index) {
      this.isPlateHoverTooltipActive = false;
      const anchorElement = event?.currentTarget;
      if (!anchorElement) return;
      if (!this.releasePlateHoverBlockIfMoved(event)) {
        return;
      }
      const pointerPosition = event ? { clientX: event.clientX, clientY: event.clientY } : null;
      this.schedulePlateHoverOpen(anchorElement, coluna, index, pointerPosition, 620);
    },
    handlePlateHoverCellMove(event, pratos, index) {
      const anchorElement = event?.currentTarget;
      if (!anchorElement) return;
      if (!this.releasePlateHoverBlockIfMoved(event)) {
        return;
      }
      if (this.plateHoverCard.visible || this.plateHoverOpenTimeout) {
        return;
      }
      const pointerPosition = { clientX: event.clientX, clientY: event.clientY };
      this.schedulePlateHoverOpen(anchorElement, pratos, index, pointerPosition, 620);
    },
    handlePlateHoverCellLeave(event) {
      this.clearPlateHoverOpenTimeout();
      const nextTarget = event?.relatedTarget;
      if (this.isPlateHoverTooltipElement(nextTarget)) {
        return;
      }
      if (this.isPlateHoverCellElement(nextTarget)) {
        return;
      }
      this.schedulePlateHoverClose();
    },
    handlePlateHoverTooltipEnter() {
      this.isPlateHoverTooltipActive = true;
      this.clearPlateHoverCloseTimeout();
    },
    handlePlateHoverTooltipLeave(event) {
      this.isPlateHoverTooltipActive = false;
      const nextTarget = event?.relatedTarget;
      if (this.isPlateHoverCellElement(nextTarget)) {
        return;
      }
      this.schedulePlateHoverClose();
    },
    handlePlateHoverTooltipClose() {
      this.plateHoverBlockedUntilMove = true;
      this.plateHoverBlockedPointer = null;
      this.hidePlateHoverCardImmediate();
    },
    clearColumnHoverOpenTimeout() {
      if (this.columnHoverOpenTimeout) {
        clearTimeout(this.columnHoverOpenTimeout);
        this.columnHoverOpenTimeout = null;
      }
    },
    clearColumnHoverCloseTimeout() {
      if (this.columnHoverCloseTimeout) {
        clearTimeout(this.columnHoverCloseTimeout);
        this.columnHoverCloseTimeout = null;
      }
    },
    releaseColumnHoverBlockIfMoved(event) {
      if (!this.columnHoverBlockedUntilMove) return true;
      const clientX = event?.clientX;
      const clientY = event?.clientY;

      if (clientX === undefined || clientY === undefined) {
        this.columnHoverBlockedUntilMove = false;
        this.columnHoverBlockedPointer = null;
        return true;
      }

      if (!this.columnHoverBlockedPointer) {
        this.columnHoverBlockedPointer = { clientX, clientY };
        return false;
      }

      if (clientX === this.columnHoverBlockedPointer.clientX && clientY === this.columnHoverBlockedPointer.clientY) {
        return false;
      }

      this.columnHoverBlockedUntilMove = false;
      this.columnHoverBlockedPointer = null;
      return true;
    },
    isColumnHoverTooltipElement(element) {
      return !!(element && typeof element.closest === 'function' && element.closest('.plate-column-hover-card'));
    },
    isColumnHoverCellElement(element) {
      return !!(element && typeof element.closest === 'function' && element.closest('.column-header-hover-trigger[data-column-hover-seq]'));
    },
    openColumnHoverCard(anchorElement, headerData, pointerPosition = null) {
      const content = this.buildColumnHoverCardContent(headerData);
      if (!anchorElement || !content) {
        this.hideColumnHoverCardImmediate();
        return;
      }

      this.columnHoverCard = {
        visible: true,
        position: this.calculateFloatingHoverCardPosition(anchorElement, pointerPosition, {
          preferredWidth: 380,
          minWidth: 320,
          preferredHeight: 600,
          minHeight: 600,
          offset: 10
        }),
        content,
        context: { headerData, anchorElement, pointerPosition }
      };
    },
    scheduleColumnHoverOpen(anchorElement, headerData, pointerPosition = null, delayMs = 500) {
      this.clearColumnHoverOpenTimeout();
      this.clearColumnHoverCloseTimeout();
      this.columnHoverOpenTimeout = setTimeout(() => {
        this.openColumnHoverCard(anchorElement, headerData, pointerPosition);
        this.columnHoverOpenTimeout = null;
      }, delayMs);
    },
    scheduleColumnHoverClose(delayMs = 120) {
      this.clearColumnHoverCloseTimeout();
      this.columnHoverCloseTimeout = setTimeout(() => {
        if (this.isColumnHoverTooltipActive) {
          this.columnHoverCloseTimeout = null;
          return;
        }
        this.hideColumnHoverCardImmediate();
        this.columnHoverCloseTimeout = null;
      }, delayMs);
    },
    hideColumnHoverCardImmediate() {
      this.clearColumnHoverOpenTimeout();
      this.clearColumnHoverCloseTimeout();
      if (!this.columnHoverCard.visible && !this.columnHoverCard.content) return;
      this.isColumnHoverTooltipActive = false;
      this.columnHoverCard = {
        visible: false,
        position: { top: 0, left: 0, maxHeight: 0, width: 0, maxWidth: 0 },
        content: null,
        context: null
      };
    },
    handleColumnHoverCellEnter(event, headerData) {
      this.isColumnHoverTooltipActive = false;
      const anchorElement = event?.currentTarget;
      if (!anchorElement) return;
      if (!this.releaseColumnHoverBlockIfMoved(event)) return;
      const pointerPosition = event ? { clientX: event.clientX, clientY: event.clientY } : null;
      this.scheduleColumnHoverOpen(anchorElement, headerData, pointerPosition, 500);
    },
    handleColumnHoverCellMove(event, headerData) {
      const anchorElement = event?.currentTarget;
      if (!anchorElement) return;
      if (!this.releaseColumnHoverBlockIfMoved(event)) return;
      if (this.columnHoverCard.visible || this.columnHoverOpenTimeout) return;
      const pointerPosition = { clientX: event.clientX, clientY: event.clientY };
      this.scheduleColumnHoverOpen(anchorElement, headerData, pointerPosition, 500);
    },
    handleColumnHoverCellLeave(event) {
      this.clearColumnHoverOpenTimeout();
      const nextTarget = event?.relatedTarget;
      if (this.isColumnHoverTooltipElement(nextTarget) || this.isColumnHoverCellElement(nextTarget)) {
        return;
      }
      this.scheduleColumnHoverClose();
    },
    handleColumnHoverTooltipEnter() {
      this.isColumnHoverTooltipActive = true;
      this.clearColumnHoverCloseTimeout();
    },
    handleColumnHoverTooltipLeave(event) {
      this.isColumnHoverTooltipActive = false;
      const nextTarget = event?.relatedTarget;
      if (this.isColumnHoverCellElement(nextTarget)) {
        return;
      }
      this.scheduleColumnHoverClose();
    },
    handleColumnHoverTooltipClose() {
      this.columnHoverBlockedUntilMove = true;
      this.columnHoverBlockedPointer = null;
      this.hideColumnHoverCardImmediate();
    },
    handleGlobalPlateHoverMouseMove(event) {
      this.releasePlateHoverBlockIfMoved(event);
      this.releaseColumnHoverBlockIfMoved(event);
    },
    setColorForGroup: function (coluna) {
      if(this.exibitionMode && this.exibitionMode.states && this.exibitionMode.states.groupsOnPointer && coluna.id_prato) {

        this.resetAllUiState();
        const pratosInfo = this.cardData.dataCatalog.pratos;
        const grupo = pratosInfo?.[coluna.id_prato]?.id_grupo;

        if (!grupo) return;

        // percorre os dias já indexados
        this.ctxByDia.forEach((ctx, data) => {

          const colunas = ctx.colunasByGrupo.get(grupo) || [];

          colunas.forEach((c) => {
            const cellKey = this.makeCellKeyFromColuna(c, data);

            const entry = this.getOrCreateUiEntry(cellKey);
            entry.style = 'background-color: firebrick';

            this.applyContrastToEntry(entry);
          });

        });  
      }
    },

    publishCard: function () {
      const CONFIRM_PUBLISH_CARD = t('confirm_publish_card');
      Util.showConfirmationDialog(this.$modal, {
        onModalClose: function (confirmPublishCard) {
          if (confirmPublishCard) {
            this.unclickable = "pointer-events: none;";
            this.loading = true;
            requestModule
              .postRequest(
                `publishCard`,
                {
                  cardapio: this.cardData.dataCatalog.tabela,
                  colunas: this.cardData.dataCatalog.colunas,
                  dadosCenario: this.nrcenario,
                }
              )
              .then((response) => {
                const sucesso = response?.dataset?.status?.sucesso;
                const erros = response?.dataset?.status?.erros;
                if (sucesso) {
                  Util.showSuccessNotification({
                    text: t('published_menu_moment', { PARAM: `${moment().format("HH:mm:ss")}` }),
                    title: t('published_menu'),
                  });
                  return;
                }
                if (erros && erros.length) {
                  this.publishErrors = erros;
                  this.showPublishErrors = true;
                  return;
                }
                Util.showErrorNotification({
                  text: t('failed_to_publish_the_menu_consult_the_logs'),
                  title: t('error'),
                });
              })
              .catch((error) => {
                Util.showErrorNotification({
                  text: t('failed_to_publish_the_menu_consult_the_logs'),
                  title: t('error'),
                });
              })
              .finally(() => {
                this.unclickable = "pointer-events: auto;";
                this.loading = false;
              });
          }
        }.bind(this)
      }, CONFIRM_PUBLISH_CARD);
    },

    showSharePopUp: function () {
      this.resetShareDate();
      this.$modal.show("shareModal", {});
    },
    getChangedTitle(coluna) {
      const meta = coluna?._meta;
      if (!meta) return "";

      // Regra: solver não mostra nada
      if (meta.id_origem === "solver" || meta.id_origem === "solver_IA") return "";

      const old = meta.oldJson;

      // Helper pra montar mensagem com valor antigo
      const withOld = (msg, value) => {
        if (old && value !== undefined && value !== null) {
          return `${msg} - Anterior: ${value}`;
        }
        return msg;
      };

      // ORIGEM USUÁRIO
      if (meta.id_origem === "usuario") {
        switch (meta.id_acao) {
          case "exclusao_prato":
            return withOld("Prato excluído", old?.id_prato);

          case "substituicao_prato":
            return withOld("Prato substituído", old?.id_prato);

          case "ajuste_consumo":
            return withOld("Consumo ajustado", old?.perc_consumo);
        }
      }

      // ORIGEM AUTOMÁTICO
      if (meta.id_origem === "automatico") {
        if (meta.id_acao === "ajuste_consumo") {
          return withOld("Consumo ajustado automaticamente", old?.perc_consumo);
        }
      }

      return "";
    }
  },
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");



.capitalize {
  text-transform: capitalize;
}

.image-contrast {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7473%) hue-rotate(304deg) brightness(98%) contrast(109%);
}

.colored-cell {
  background: rgb(131, 58, 180);
  background: linear-gradient(45deg, rgba(131, 58, 180, 1) 0%, rgba(56, 121, 41, 1) 22%, rgba(34, 65, 163, 1) 50%, rgba(117, 119, 27, 1) 73%, rgba(140, 10, 10, 1) 100%);
}

.attached-mark {
  font-size: 0.6rem;
  position: absolute;

  img {
    vertical-align: middle;
  }

  z-index: 1;
  left: 5px;
}

.changed-mark {
  position: absolute;
  z-index: 1;
  right: 0;
  top: 0px;
  color: red;
  cursor: default;
  border-style: solid;
  border-width: 0 10px 10px 0;
  border-color: transparent red transparent transparent;
}

.ings-container {
  position: absolute;
  left: 0;
  right: 0;
  background: #f0f0f0;
  top: 0;
  bottom: 0;
  z-index: 1;

  span {
    position: relative;
    display: inline-block;
    width: 50%;
    text-align: center;
    vertical-align: middle;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    top: 45%;
    overflow: hidden;
    text-overflow: ellipsis;

    &:only-child {
      width: 100%;
      display: block;
    }
  }

  div {
    width: 50%;
    height: 100%;
    position: absolute;
    top: 0;
    margin: auto;
    display: table;
    opacity: 0.6;
    z-index: -1;

    &:last-of-type {
      left: 50%;
    }
  }
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

#share-link {
  width: 100%;
  padding-right: 30px;
  /* Espaço para o ícone */
}

.copy-button {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2em;
}




.button {
  min-width: 150px;
  padding: 6px 15px;
  margin: auto 3px;
}

.ghost {
  background-color: white;
  box-shadow: none;
  color: #dc143d;
  border: 1px solid #dc143d;
  padding: 5px 14px;

  &:hover {
    color: #212146;
    border: 1px solid #212146;
  }
}

.padlock {
  position: absolute;
  left: 85%;
  display: block;
  max-width: 10%;
  right: 0;
  background: transparent;
  top: 0;
  bottom: 0;
  margin: auto;
}

.arrow,
.arrow-secondary {
  z-index: 10;
  .sombra;
  .clicavel;
  .default-hover;
  position: fixed;
  bottom: 15px;
  border-radius: 100%;
  display: table;
}

.arrow {
  right: 35px;
}

.arrow-secondary {
  right: 90px;
  /* Distância do botão original */
}

.arrow-tertiary {
  right: 145px;
  /* Distância do botão original */
}

.arrow.arrow-tertiary.ai-report-deprecated {
  background: @azul;

  &:hover {
    background: @azul;
  }
}

.ai-report-trigger {
  position: relative;
}

.ai-report-spinner {
  position: absolute;
  width: 34px;
  height: 34px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ai-report-spin 0.9s linear infinite;
  padding: 5px;
}

@keyframes ai-report-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.img-container {
  width: 50px;
  height: 50px;
  position: relative;
}

.img {
  .full;
  margin: auto;
  position: absolute;
  background: center center;
  background-size: cover;
  width: 70%;
  height: 70%;
}

.img-share {
  width: 60%;
  height: 60%;
}

.img.inverted {
  filter: invert(1);
}

.desc {
  position: absolute;
  right: 0;
  top: -40px;
  bottom: 0;
  vertical-align: middle;
  margin: auto;
  display: table;
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
  background: @vermelho;
  padding: 0 5px;
  border-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  opacity: 0;
  white-space: nowrap;
  .default-animation;
  pointer-events: none;
  z-index: 999;
}

.arrow:hover .desc {
  background: @azul;
  opacity: 1;
  /*right: 45px;*/
}

/*.arrow-secondary .desc {*/
/*  border-radius: 5px;*/
/*  border-top-left-radius: 0;*/
/*  border-bottom-left-radius: 0;*/
/*  left: 0;*/
/*}*/

.arrow-secondary:hover .desc {
  background: @azul;
  opacity: 1;
  /*right: 45px;*/
}

.arrow-view-feedback {
  right: 145px;
}


.anal-container {
  margin: 0 15px 0 0;
}

.card-anal-container {
  .fixed-cols .dia .cell-container {
    height: 30px;
  }

  .ia-highlight-day {
    box-shadow: inset 0 0 0 2px #ff9800;
    transition: box-shadow 0.2s ease;
  }

  .ia-highlight-cell {
    box-shadow: inset 0 0 0 3px #ff5722;
    transition: box-shadow 0.2s ease;
  }

  .ia-highlight-cell.ia-highlight-usage {
    box-shadow: inset 0 0 0 3px #2e7d32;
  }

  .ia-highlight-cell.ia-highlight-candidate {
    box-shadow: inset 0 0 0 3px #f9a825;
  }

  .ia-highlight-cell.ia-highlight-conflict {
    box-shadow: inset 0 0 0 3px #c62828;
  }

  .plates .dia .container-max {
    background: rgb(240, 240, 240);

    .palate-data {
      font-size: 0.6rem;
      position: absolute;
      bottom: 2px;

      &:first-of-type {
        left: 5px;
      }

      &:last-of-type {
        right: 5px;
      }

      img {
        vertical-align: middle;
      }
    }

    &.noComens {
      background: rgba(192, 192, 192, 0.7);
    }
  }

  .dia .container-max {
    margin-bottom: 2px;
  }
}

.card-anal-container {
  overflow: auto;
  max-height: 79vh;
  font-size: 0.7rem;
  position: relative;
  display: grid;
  grid-template-columns: 110px calc(100% - 250px) 120px;

  .fixed-cols {
    position: relative;
    text-align: center;

    .dia {
      position: relative;
      display: grid;
      grid-template-columns: 100px 100px;

      //   border-bottom: solid 2px white;
      &:after {
        content: "";
        position: absolute;
        background: #fff;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
      }

      &:first-of-type {
        &:after {
          content: "";
          height: 2px;
        }
      }
    }

    &.left .dia {
      display: block;

      .coms {
        position: absolute;
        bottom: 5px;
      }

      .cell-container {
        text-indent: 10px;
        justify-content: left;
      }
    }

    &.right .dia {
      grid-template-columns: 60px 60px;
    }

    .fixed-cols-cont {
      // background: rgb(200, 200, 200);
      background: rgba(121, 119, 119, 0.2);
    }

    .overpu {
      color: rgba(255, 0, 0, 0.9);
    }
  }

  .plates {
    white-space: nowrap;
    overflow: auto hidden;
    margin: 0 2px;
  }

  .dia {
    max-height: 33px;
    height: 33px;
    display: grid;

    .container-max {
      position: relative;
      text-align: center;
      padding: 0 10px;
      text-align: center;
    }

    .cell-container {
      align-items: center;
      justify-content: center;
      display: flex;
      height: 17px;

      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;

        &.text {
          &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
          }

          &:hover {
            &:after {
              border: solid 1px red;
            }
          }
        }
      }

      &.noComens {
        background: rgba(192, 192, 192, 0.7);
      }
    }
  }
}

.anal-container {
  ::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  .labels {
    display: grid;
    grid-template-columns: 110px calc(100% - 260px) 120px;

    .tipos-pratos {
      overflow: auto;

      .dia {
        display: grid;
      }
    }

    .lab,
    .dia {
      max-height: 31px;
      margin-bottom: 2px;

      &.right {
        display: grid;
        grid-template-columns: 60px 60px;
      }
    }

    .dia {
      margin: 0 2px;
    }

    .cell-container {
      align-items: center;
      justify-content: center;
      display: flex;
      height: 17px;
      background: @azul;
      height: 31px;
      display: flex;
      vertical-align: middle;

      .cell {
        padding: 0 10px;
        text-align: center;
        font-size: 0.7rem;
        text-transform: uppercase;
        font-weight: 600;
        text-overflow: ellipsis;
        white-space: initial;
        overflow: hidden;
        display: block;
        color: white;
      }
    }
  }
}

.card-cont {
  ::-webkit-scrollbar {
    display: block;
    width: 10px;
    height: 0px !important;
  }
}

.anal-data {
  position: relative;
  display: block;
}

.hidden-controlls {
  display: none;
}

.anal-data-container {
  margin: 10px 35px 0 5px;
  position: relative;
  display: grid;
  @larg: 100% /7;
  grid-template-columns: @larg @larg @larg @larg @larg @larg @larg;

  .anal-data {
    position: relative;
    display: block;

    &:before {
      content: "";
      position: absolute;
      .full;
      border: solid 1px white;
    }

    span {
      text-align: center;
      display: block;

      &:first-of-type {
        background: @azul;
        color: white;
      }
    }
  }
}

.share-form-root {
  width: calc(100% - 40px);
  padding: 20px;

  .field.text-field textarea {
    width: 100%;
    padding: 16px;
    border: 1px solid #BDBDBD;
    box-sizing: border-box;
    border-radius: 4px;
    font-family: inherit;
    resize: vertical;
  }

  .autocomplete-field {
    .restrinctions-select-autocomplete {

      .vs__selected-options {
        height: 26px;
      }

      .vs__search {
        position: absolute;
        padding: 1px;
        border: none;
      }


    }
  }

  .date-fields-container {
    .field {
      width: 44%;
      display: inline-block;
    }
  }

  .export-container {
    display: inline-block;
    // margin: 10px;
    text-align: left;
    font-size: .9rem;
    width: calc(100%);
  }

  .field {
    display: inline-block;
    text-align: left;
    font-size: .9rem;
    width: calc(100%);

    &.text-field {
      input {
        padding: 6px 0px 7px 8px;
      }
    }

    input {
      padding: 5px;
      border: 1px solid #BDBDBD;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;

      &.input-label {
        border: none;
        border-bottom: 1px solid #BDBDBD;
        border-radius: 0;
      }
    }

    input[type="date"] {
      width: 70%;
    }

  }

}

.copy-icon {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 20px;
  height: 20px;
}

@media screen and (max-width: 1271px) {
  // .anal-data-container {
  //   grid-template-columns: 50% 50%;
  // }
}
</style>
